/* AstroIndie storefront behaviour: arrival and scroll motion, menu, loading the chart engine that sits
   directly in the page, the free-chart PDF by email, the next step after a
   free Kundli, the order form, sticky buy bar, sample pages, and analytics. */
/* The site's language: aiT(text) gives the Hindi wording when the visitor
   reads in हिन्दी (filled in by the language block near the end of this file). */
window.aiT = window.aiT || function (t) { return t; };
/* Has this visitor bought (or just gone to pay)? Then the leaving offer and
   the other "before you go" nudges are never shown: a buyer who has paid must
   not be offered money off on their way out.
     - signed in with orders on the account (told by the page);
     - a paid order seen on this device in the last 60 days (ai_bought);
     - an order sent to payment in the last 3 days whose outcome is not known
       yet (ai_pending_order): the cart check after payment settles it, and an
       unpaid, abandoned checkout lets the offer back in. */
window.aiIsBuyer = function () {
  if (window.AI && AI.buyer) return true;
  try {
    var t = +localStorage.getItem('ai_bought');
    if (t && Date.now() - t < 60 * 864e5) return true;
    if (localStorage.getItem('ai_pending_order') && !window.__aiCheckoutOpen) return true;
  } catch (e) {}
  return false;
};
/* A short message at the bottom of the screen ("Discount code copied"), read out by screen readers too. */
window.aiToast = function (msg, ms) {
  var t = document.getElementById('ai-toast');
  if (!t) { t = document.createElement('div'); t.id = 'ai-toast'; t.className = 'ai-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
  t.textContent = msg;
  t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
  clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, ms || 3200);
};
/* aiTf('{0} chapter until {1}', 'Saturn', 'Mar 2031'): the same, with the
   changing parts filled in (and put into Hindi too, for planet, sign and month names) */
window.aiTf = window.aiTf || function (t) { var a = [].slice.call(arguments, 1); return String(t).replace(/\{(\d+)\}/g, function (m, i) { return a[+i] == null ? '' : a[+i]; }); };
/* An error is shown right under the field it belongs to, in the form's language,
   and cleared as soon as the buyer changes that field. */
window.aiFieldError = function (el, msg) {
  var f = el.closest('.field') || el.parentElement;
  if (!f) return;
  f.classList.add('is-invalid');
  var p = f.querySelector(':scope > .field__err');
  if (!p) { p = document.createElement('p'); p.className = 'field__err'; p.setAttribute('role', 'alert'); f.appendChild(p); }
  p.textContent = msg;
  var clear = function () { f.classList.remove('is-invalid'); if (p.parentNode) p.remove(); f.removeEventListener('input', clear); f.removeEventListener('change', clear); };
  f.addEventListener('input', clear); f.addEventListener('change', clear);
};

/* ---------- Day / month / year and hour / minute dropdowns ----------
   Each group writes one hidden field: YYYY-MM-DD for a date, 24-hour HH:MM for
   a time. The hidden field is the one the order carries, so everything that
   reads the form (the order, the mailer, the pre-fill) sees what it always did. */
(function () {
  var p2 = function (n) { return String(n).padStart(2, '0'); };
  function init(box) {
    if (!box || box._dp) return;
    box._dp = 1;
    var out = box.querySelector('[data-dp-out]');
    var time = box.getAttribute('data-dparts') === 'time';
    var sel = function (k) { return box.querySelector('[data-dp="' + k + '"]'); };
    var all = box.querySelectorAll('select');
    function sync() {
      var v = '';
      if (time) {
        var h = sel('h').value, mi = sel('mi').value, ap = sel('ap').value;
        if (h !== '' && mi !== '' && ap) v = p2((+h % 12) + (ap === 'PM' ? 12 : 0)) + ':' + p2(mi);
      } else {
        var d = sel('d').value, m = sel('m').value, y = sel('y').value, msg = '';
        if (d && m) {
          /* 30 February and the like: say so on the day box rather than quietly fixing it */
          var max = new Date(y ? +y : 2000, +m, 0).getDate();
          if (+d > max) msg = window.aiT('That month has only {n} days.').replace('{n}', max);
        }
        if (d && m && y && !msg) {
          v = y + '-' + p2(m) + '-' + p2(d);
          var t = new Date(), today = t.getFullYear() + '-' + p2(t.getMonth() + 1) + '-' + p2(t.getDate());
          if (v > today) { msg = window.aiT('This date is in the future.'); v = ''; }
        }
        sel('d').setCustomValidity(msg);
      }
      if (out.value !== v) { out.value = v; out.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    box.addEventListener('change', function (e) { if (e.target !== out) sync(); });
    out._aiSet = function (v) {
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(v || ''), t = /^(\d{1,2}):(\d{2})/.exec(v || '');
      if (!time && m) { sel('y').value = String(+m[1]); sel('m').value = String(+m[2]); sel('d').value = String(+m[3]); }
      else if (time && t) { var H = +t[1]; sel('h').value = String(H % 12 || 12); sel('mi').value = String(+t[2]); sel('ap').value = H >= 12 ? 'PM' : 'AM'; }
      else all.forEach(function (x) { x.value = ''; });
      sync();
    };
    out._aiOff = function (off) {
      all.forEach(function (x) { x.disabled = off; if (off) x.value = ''; });
      out.disabled = off;
      box.classList.toggle('is-off', off);
      sync();
    };
    /* what the visitor sees: "15 May 1990", "10:30 AM" */
    out._aiText = function () {
      if (!out.value) return '';
      if (time) return sel('h').value + ':' + p2(sel('mi').value) + ' ' + sel('ap').value;
      var mo = sel('m'); return sel('d').value + ' ' + mo.options[mo.selectedIndex].text + ' ' + sel('y').value;
    };
  }
  window.aiDparts = init;
  document.querySelectorAll('[data-dparts]').forEach(init);
})();

(function () {
  'use strict';
  var AI = window.AI || {};
  var $id = function (i) { return document.getElementById(i); };

  /* ---------- analytics: one call, every listener ----------
     Shopify customer events (custom pixels, Google & YouTube app), a GTM
     dataLayer and gtag if present. Nothing is sent anywhere by this theme. */
  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
    try {
      if (typeof window.fbq === 'function' && name === 'astroindie_buy_now') {
        var m = window.AI_META || {};
        window.fbq('track', 'InitiateCheckout', m.id ? { content_ids: [m.id], content_name: m.name, content_type: 'product', value: m.value, currency: m.currency, num_items: 1 } : {});
      }
    } catch (e) {}
  }
  window.aiTrack = track;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-track]');
    if (t) track(t.getAttribute('data-track'), { mode: t.getAttribute('data-mode') || '', page: AI.tpl || '' });
  }, true);

  /* ---------- mobile menu ----------
     Opens below the header wherever the header is on screen (the announcement
     bar above it scrolls away), locks the page behind it, and closes on a link,
     on Escape, on the X, or when the screen grows past phone width. */
  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = $id('drawer');
  if (toggle && drawer) {
    var hdr = document.querySelector('.site-header');
    var setMenu = function (open) {
      if (open && hdr) {
        var b = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
        document.documentElement.style.setProperty('--drawer-top', b + 'px');
      }
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      document.documentElement.classList.toggle('menu-open', open);
      if (open) track('astroindie_menu_open', { page: AI.tpl || '' });
    };
    toggle.addEventListener('click', function () { setMenu(drawer.hidden); });
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      setMenu(false);
      /* Same-page anchor (e.g. /#free-kundli while on the home page): scroll there ourselves,
         after the page is unlocked, so it lands below the sticky header. */
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.pathname === location.pathname && u.search === location.search && u.hash) {
        var t = document.getElementById(u.hash.slice(1));
        if (t) {
          e.preventDefault();
          var off = hdr ? hdr.getBoundingClientRect().height : 0;
          window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off - 8, behavior: 'smooth' });
          try { history.replaceState(null, '', u.hash); } catch (err) {}
        }
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) { setMenu(false); toggle.focus(); } });
    window.addEventListener('resize', function () { if (!drawer.hidden && window.innerWidth > 960) setMenu(false); });
    window.addEventListener('pageshow', function () { if (!drawer.hidden) setMenu(false); });
  }

  /* ---------- shared script loader (each file downloads once) ---------- */
  var SCRIPTS = {};
  /* Ordered by default (the engine needs its data first); pass true for a file
     nothing waits on, so it never holds up the scripts queued after it. */
  function loadScript(src, independent) {
    if (!SCRIPTS[src]) {
      SCRIPTS[src] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src; s.async = !!independent; s.onload = resolve;
        s.onerror = function (e) { delete SCRIPTS[src]; reject(e); };
        document.body.appendChild(s);
      });
    }
    return SCRIPTS[src];
  }

  function loadScripts(list) { return Promise.all(list.map(function (src) { return loadScript(src); })); }

  function toast(msg, bad) {
    var t = document.createElement('div');
    t.className = 'ga-toast' + (bad ? ' is-bad' : '');
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 400); }, 6500);
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* ---------- chart engine ---------- */
  var FREE = ['kundali', 'match', 'rectify', 'muhurta', 'prashna'];
  var root = document.querySelector('.jk-root[data-jk-lazy]');
  var q; try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
  var chipNav = document.querySelector('[data-default-tool]');
  var engineReady = false, waiting = [];

  function whenReady(fn) { if (engineReady) fn(); else waiting.push(fn); }

  function scrollToEngine() {
    if (!root) return;
    var header = document.querySelector('.site-header');
    var off = header ? header.getBoundingClientRect().height : 0;
    var y = root.getBoundingClientRect().top + window.pageYOffset - off - 12;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  if (root) {
    /* Free tools page: no ?mode= means "show the tool chosen in the editor". */
    if (chipNav && q && !q.get('mode')) {
      var def = chipNav.getAttribute('data-default-tool');
      if (def && def !== 'kundali' && FREE.indexOf(def) > -1) {
        whenReady(function () { if (window.__setMode) window.__setMode(def); });
      }
    }

    var started = false;
    var frame = root.closest('.frame');
    var status = frame ? frame.querySelector('.frame__status') : null;
    var load = function () {
      if (started) return;
      started = true;
      /* The report has its own two typefaces. They are fetched here, with the
         calculator, so pages that never make a chart never download them. */
      if (!document.getElementById('ai-report-fonts')) {
        var fl = document.createElement('link');
        fl.id = 'ai-report-fonts'; fl.rel = 'stylesheet';
        fl.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=Hanken+Grotesk:wght@400;500;600;700&display=swap';
        document.head.appendChild(fl);
      }
      /* All three download at once (async=false keeps them running in order),
         instead of one after another: on a phone this roughly halves the wait. */
      loadScripts([root.dataset.srcEphem, root.dataset.srcCities, root.dataset.srcEngine])
        .then(function () {
          engineReady = true;
          if (frame) frame.classList.add('is-ready');
          /* Anything typed into a place field while the data was still loading:
             show its suggestions now instead of waiting for the next key. */
          ['fplace', 'bplace'].forEach(function (id) {
            var el = $id(id);
            if (el && el.value && document.activeElement === el) el.dispatchEvent(new Event('input'));
          });
          waiting.splice(0).forEach(function (fn) { try { fn(); } catch (e) { console.error(e); } });
        })
        .catch(function () { if (status) status.textContent = 'The calculator could not load. Please refresh the page.'; });
    };
    root.addEventListener('focusin', load);
    root.addEventListener('pointerdown', load);
    if (root.dataset.eager === '1') {
      /* The form is the first thing on the page: fetch the engine as soon as the page is idle. */
      if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 1500 }); else setTimeout(load, 300);
    }
    if (q && (q.get('mode') || q.get('auto') || q.get('date'))) load();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '900px 0px' });
      io.observe(root);
    } else {
      load();
    }
    /* Arriving with a prefilled, auto-cast link (from My reports): bring the report into view. */
    if (q && q.get('auto') === '1') whenReady(function () { setTimeout(scrollToEngine, 400); });

    /* The landing hero steps aside once the chart is on screen. */
    whenReady(function () {
      var gate = $id('gate');
      var hk = root.closest('.hk');
      if (!gate) return;
      var wasLive = !!gate.hidden;
      var sync = function () {
        var live = !!gate.hidden;
        document.body.classList.toggle('jk-live', live);
        if (hk) hk.classList.toggle('is-live', live);
        /* The hero copy steps aside a moment after the chart appears, which moves
           the chart up the page: bring its top back to just under the header. */
        if (live && !wasLive && hk) {
          requestAnimationFrame(function () {
            var header = document.querySelector('.site-header');
            var hb = header ? header.getBoundingClientRect().bottom : 0;
            var top = root.getBoundingClientRect().top;
            if (top < hb - 4 || top > hb + 60) window.scrollTo({ top: Math.max(0, top + window.pageYOffset - hb - 8), behavior: 'auto' });
          });
        }
        wasLive = live;
      };
      sync();
      new MutationObserver(sync).observe(gate, { attributes: true, attributeFilter: ['hidden'] });
    });
  }

  /* ---------- after a result is on screen ---------- */
  var firstKundli = true;
  var askMail = !!(root && root.dataset.askMail === '1' && root.dataset.mailer);
  var mailUrl = askMail ? root.dataset.mailer.replace(/\/$/, '') + '/api/free-chart' : '';
  function val(i) { var el = $id(i); return el ? el.value : ''; }
  function chartKey() { return [val('fdate'), val('ftime'), val('flat'), val('flon')].join('|'); }
  var sentFor = {};

  function sendChart(email, phone, hp) {
    return fetch(mailUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: val('fname'), date: val('fdate'), time: val('ftime'), place: val('fplace'),
        lat: val('flat'), lon: val('flon'), tz: val('ftz'),
        email: email, phone: phone, hp: hp || ''
      })
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function checkContact(email, phone) {
    var digits = phone.replace(/\D/g, '');
    return {
      badE: !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email),
      badP: digits.length < 8 || digits.length > 15      // the mailer requires a mobile number
    };
  }

  /* The free chart is on screen at once; this card sits right under its first
     section and makes keeping it one tap: download the PDF now, or (when the
     mailer is connected) have a copy emailed, which also saves the lead. */
  function pdfNow(btn) {
    if (typeof window.downloadPDF !== 'function') return;
    track('astroindie_free_pdf', { page: AI.tpl || '' });
    lsSet('ai_got_pdf', '1');
    if (btn) { btn.disabled = true; setTimeout(function () { btn.disabled = false; }, 4000); }
    window.downloadPDF();
  }
  function leadCard() {
    var key = chartKey();
    var box = document.createElement('div');
    box.className = 'ai-leadcard ai-freecard';
    box.id = 'ai-leadcard';
    var mailPart = '';
    if (askMail) {
      mailPart = sentFor[key]
        ? '<p class="ai-ok">&#10003; A copy is on its way to ' + esc(sentFor[key]) + '.</p>'
        : '<button class="ai-freecard__mailbtn" type="button" aria-expanded="false">Email it to me instead</button>' +
          '<div class="ai-freecard__mail"><p class="ai-freecard__or">Prefer it in your inbox? We will email you a copy too.</p>' +
          '<form novalidate>' +
          '<label>Email<input type="email" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com" required></label>' +
          '<label>Mobile number<input type="tel" name="phone" autocomplete="tel" inputmode="tel" placeholder="+91 98765 43210" required></label>' +
          '<input type="text" name="hp" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0">' +
          '<button class="gbtn gbtn--ink" type="submit">Email me a copy</button>' +
          '</form><p class="ai-bad" role="status"></p></div>';
    }
    box.innerHTML =
      '<div class="ai-freecard__top">' +
        '<div><h3>Your free Kundli is ready</h3>' +
        '<p>Save it as a PDF to keep, print or share with your family. No sign-up.</p></div>' +
        '<button class="gbtn gbtn--buy" type="button" data-ai-pdf>' +
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M7 10l5 5 5-5M5 21h14"/></svg>' +
          ' Download PDF</button>' +
      '</div>' + mailPart;
    box.querySelector('[data-ai-pdf]').addEventListener('click', function () { pdfNow(this); });
    /* phones: the email form opens on request, so the card stays one screen-friendly block */
    var mb = box.querySelector('.ai-freecard__mailbtn');
    if (mb) mb.addEventListener('click', function () {
      box.classList.add('is-mail'); mb.setAttribute('aria-expanded', 'true');
      var e1 = box.querySelector('input[name="email"]'); if (e1) e1.focus();
    });
    var f = box.querySelector('form');
    if (!f) return box;
    var em = f.email, ph = f.phone, msg = box.querySelector('.ai-bad');
    em.value = lsGet('ai_email') || ''; ph.value = lsGet('ai_phone') || '';
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = em.value.trim(), phone = ph.value.trim(), c = checkContact(email, phone);
      em.classList.toggle('is-bad', c.badE); ph.classList.toggle('is-bad', c.badP);
      if (c.badE || c.badP) { msg.textContent = 'Please enter a valid email and mobile number.'; (c.badE ? em : ph).focus(); return; }
      msg.textContent = '';
      lsSet('ai_email', email); lsSet('ai_phone', phone);
      var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = 'Sending…';
      sendChart(email, phone, f.hp.value).then(function (x) {
        if (x.ok) {
          sentFor[key] = email;
          f.outerHTML = '<p class="ai-ok">&#10003; Sent. A copy is on its way to ' + esc(email) + '. It usually arrives within a few minutes.</p>';
          track('astroindie_lead', { page: AI.tpl || '' });
        } else {
          btn.disabled = false; btn.textContent = 'Email me a copy';
          msg.textContent = (x.j && x.j.error) || 'We could not email your chart just now. The Download PDF button works straight away.';
        }
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Email me a copy';
        msg.textContent = 'We could not email your chart just now. The Download PDF button works straight away.';
      });
    });
    return box;
  }

  /* A few facts from the Kundli on screen (rising sign, Moon sign, the life
     chapter running now), so the offer of the full report can be about this
     visitor's own chart. Null until a Kundli has been cast. */
  window.aiFacts = function () {
    try {
      if (typeof CH === 'undefined' || !CH || !CH.P || !CH.vim || typeof SIGNS === 'undefined') return null;
      var now = new Date(), md = null;
      CH.vim.tree.forEach(function (m) { if (m.start <= now && now < m.end) md = m; });
      var nm = ((CH.inp && CH.inp.name) || '').trim();
      if (/^example/i.test(nm)) nm = '';
      return {
        name: (nm.split(/\s+/)[0] || '').slice(0, 24),
        asc: CH.unknownTime ? '' : SIGNS[CH.ascSign], moon: SIGNS[CH.P.Moon.sign],
        lord: md ? md.lord : '',
        until: md ? md.end.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' }) : ''
      };
    } catch (e) { return null; }
  };
  var FULL = AI.full || {};
  var BUY = AI.buy || 'Get my report';                       // one wording on every button that buys
  var kundliLive = false;

  /* Phones: the Full Birth Chart stays one tap away in a bar at the bottom,
     on every page that is not already a report's own order page. It steps
     aside while a main button for it (or the free Kundli button) is on screen,
     and while the keyboard is up. Once a Kundli is cast it speaks about that chart. */
  var stickyNext = null;
  function stickyText() {
    if (!stickyNext) return;
    var f = kundliLive ? window.aiFacts() : null;
    stickyNext.querySelector('b').textContent = f && f.lord ? window.aiTf('{0} chapter until {1}', f.lord, f.until) : window.aiT('Full Birth Chart');
    stickyNext.querySelector('span').textContent = window.aiT(f && f.lord ? 'What it means for you: full report' : 'Fine-tuned to your life events');
    stickyNext.querySelector('a').textContent = window.aiT(BUY);
  }
  function nextSticky() {
    if (stickyNext || !FULL.url || !window.matchMedia('(max-width:960px)').matches) return;
    if ($id('buy-form') || document.querySelector('[data-sticky-buy]')) return;
    if (/^(cart|password|gift_card|404)$/.test(AI.tpl || '') || /customers/.test(AI.tpl || '')) return;
    stickyNext = document.createElement('div');
    stickyNext.className = 'ai-sticky ai-sticky--mobile ai-sticky--full';
    stickyNext.innerHTML = '<div class="ai-sticky__txt"><b></b><span></span></div>' +
      '<a class="gbtn gbtn--buy" href="' + FULL.url + '#buy" data-track="astroindie_sticky_full" data-mode="birth"></a>';
    document.body.appendChild(stickyNext);
    stickyText();
  }
  function updateNextSticky() {
    if (!stickyNext) return;
    var on = window.pageYOffset > 420;
    if (on) document.querySelectorAll('[data-full-cta], #cast').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width && r.top < window.innerHeight && r.bottom > 0) on = false;
    });
    var ae = document.activeElement;
    if (ae && /^(INPUT|SELECT|TEXTAREA)$/.test(ae.tagName)) on = false;
    if (document.documentElement.classList.contains('menu-open')) on = false;
    stickyNext.classList.toggle('is-on', on);
    document.body.classList.toggle('has-sticky', on);
  }
  nextSticky();
  document.addEventListener('ai:lang', stickyText);
  window.addEventListener('scroll', function () { if (stickyNext) requestAnimationFrame(updateNextSticky); }, { passive: true });
  document.addEventListener('focusin', updateNextSticky);
  document.addEventListener('focusout', function () { setTimeout(updateNextSticky, 80); });

  /* The home page's free Kundli can sit folded behind one button: open it in place. */
  var fold = document.querySelector('[data-hk-fold]');
  window.aiOpenFree = function () {
    if (!fold) return;
    var form = fold.querySelector('.hk__form');
    var btn = fold.querySelector('[data-hk-open]');
    if (!form || !form.hidden) return;
    form.hidden = false;
    fold.classList.add('is-open');
    if (btn) { btn.setAttribute('aria-expanded', 'true'); btn.hidden = true; }
    track('astroindie_free_open', { page: AI.tpl || '' });
  };
  if (fold) {
    fold.addEventListener('click', function (e) {
      if (!e.target.closest('[data-hk-open]')) return;
      window.aiOpenFree();
      setTimeout(function () { var f = $id('fname'); if (f && f.offsetParent) f.focus({ preventScroll: true }); }, 300);
      var box = fold.querySelector('.hk__form');
      var h = document.querySelector('.site-header');
      if (box && window.innerWidth < 900) window.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + window.pageYOffset - (h ? h.getBoundingClientRect().height : 0) - 12), behavior: 'smooth' });
    });
    var qs = null; try { qs = new URLSearchParams(location.search); } catch (e) {}
    if (location.hash === '#' + fold.id || location.hash === '#free-chart' || (qs && (qs.get('mode') || qs.get('auto') || qs.get('date')))) window.aiOpenFree();
    window.addEventListener('hashchange', function () { if (location.hash === '#' + fold.id) window.aiOpenFree(); });
  }

  /* "or start with a free Kundli": to the form, ready to type */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-go-free]');
    if (!a) return;
    var root = document.querySelector('.hk .jk-root');
    if (!root) return;
    e.preventDefault();
    if (window.aiOpenFree) window.aiOpenFree();
    var h = document.querySelector('.site-header');
    var box = root.closest('.frame') || root;
    window.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + window.pageYOffset - (h ? h.getBoundingClientRect().height : 0) - 12), behavior: 'smooth' });
    setTimeout(function () { var f = $id('fname'); if (f && f.offsetParent) f.focus({ preventScroll: true }); }, 450);
  });

  document.addEventListener('jk:result', function (e) {
    var d = e.detail || {};
    var rep = $id('report');
    if (!rep) return;
    if (d.kind === 'kundali' && firstKundli) {
      firstKundli = false;
      track('astroindie_free_kundli', { page: AI.tpl || '', locked_report: d.locked || '' });
    } else if (d.kind && d.kind !== 'kundali') {
      track('astroindie_tool_used', { tool: d.kind, page: AI.tpl || '' });
    }
    var freeChart = d.kind === 'kundali' && (d.preview === 'full' || d.preview === 'quick');
    kundliLive = freeChart;
    /* Keep the chart: download now, or email a copy. Shown with the chart, never before it. */
    if (freeChart && !$id('ai-leadcard')) {
      /* first thing in the reading, so keeping it never means scrolling for it */
      var first = rep.querySelector('section');
      var card = leadCard();
      if (first) rep.insertBefore(card, first); else rep.appendChild(card);
    }
    /* The next step: the reports, as the answers to the questions people bring. */
    var tpl = $id('ai-next-tpl');
    if (freeChart && tpl && !$id('ai-next')) {
      var foot = rep.querySelector(':scope > footer');
      if (foot) rep.insertBefore(tpl.content.cloneNode(true), foot); else rep.appendChild(tpl.content.cloneNode(true));
      var fx = window.aiFacts(), slot = rep.querySelector('[data-ai-facts]');
      if (fx && fx.lord && slot) slot.textContent = window.aiTf('You are in your {0} chapter until {1}.', fx.lord, fx.until) + ' ';
    }
    nextSticky();
    stickyText();
    updateNextSticky();
  });

  /* ---------- free tools page: switch tool without reloading ---------- */
  function markChip(mode) {
    document.querySelectorAll('[data-tool-chip]').forEach(function (c) {
      c.setAttribute('aria-current', String(c.getAttribute('data-tool-chip') === mode));
    });
  }
  document.querySelectorAll('[data-tool-chip]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      if (!engineReady || !window.__setMode) return;   // not loaded yet: follow the link
      e.preventDefault();
      var mode = chip.getAttribute('data-tool-chip');
      var gate = $id('gate');
      var reset = $id('reset');
      if (gate && gate.hidden && reset) reset.click();
      window.__setMode(mode);
      markChip(mode);
      try { history.replaceState(null, '', chip.getAttribute('href')); } catch (err) {}
      scrollToEngine();
    });
  });
  if (q && q.get('mode') && FREE.indexOf(q.get('mode')) > -1) markChip(q.get('mode'));

  /* ---------- birth-place search in the report buy form ---------- */
  /* The 4 MB list of Indian towns is parsed and searched in a background
     worker, so typing never stalls the page (a slow tap response is what
     Google's INP score measures). */
  var IW = null, IW_READY = false, IW_RES = {}, IW_ASKED = {}, IW_DONE = null;
  var IW_CODE = 'self.window=self;self.onmessage=function(e){if(e.data.src){try{importScripts(e.data.src)}catch(x){postMessage({fail:1});return}' +
    'var D=self.__JK_INDIA;if(!D||!D.p){postMessage({fail:1});return}self.D=D;self.K=D.p.map(function(r){return r[0].toLowerCase()});postMessage({ready:1});return}' +
    'var q=e.data.q,K=self.K,D=self.D,s=[],h=[];for(var i=0;i<K.length;i++){var k=K[i];if(k.indexOf(q)===0){s.push(i);if(s.length>=40)break}' +
    'else if(q.length>=4&&h.length<20&&k.indexOf(q)>-1)h.push(i)}postMessage({q:q,rows:s.concat(h).map(function(i){var r=D.p[i],d=D.d[r[1]];' +
    'return{name:r[0],country:d[0]+", "+D.s[d[1]]+", India",lat:r[2]/100,lon:r[3]/100,tz:"Asia/Kolkata",pop:null}})})};';
  function indiaWorker(src, onData) {
    IW_DONE = onData;
    if (IW || IW_READY || !src || typeof Worker !== 'function') return;
    try {
      IW = new Worker(URL.createObjectURL(new Blob([IW_CODE], { type: 'text/javascript' })));
      IW.onmessage = function (e) {
        var m = e.data || {};
        if (m.fail) { IW.terminate(); IW = null; return; }
        if (m.ready) { IW_READY = true; if (IW_DONE) IW_DONE(); return; }
        IW_RES[m.q] = m.rows;
        if (IW_DONE) IW_DONE(m.q);
      };
      IW.onerror = function () { if (IW) IW.terminate(); IW = null; IW_READY = false; };
      IW.postMessage({ src: new URL(src, location.href).href });
    } catch (e) { IW = null; }
  }
  function citySearch(q) {
    var C = window.__JK_CITIES;
    if (!C) return [];
    if (!C._idx) C._idx = C.c.map(function (r) { return r[0].toLowerCase(); });
    q = q.split(',')[0].trim().toLowerCase();
    if (q.length < 2) return [];
    var starts = [], has = [];
    for (var i = 0; i < C._idx.length; i++) {
      var k = C._idx[i];
      if (k.indexOf(q) === 0) { starts.push(i); if (starts.length >= 40) break; }
      else if (has.length < 20 && k.indexOf(q) > -1) has.push(i);
    }
    var out = starts.concat(has).slice(0, 25).map(function (i) {
      var r = C.c[i];
      return { name: r[0], country: C.ccn[r[1]], lat: r[2], lon: r[3], tz: C.tz[r[4]], pop: r[5] };
    });
    /* Every Indian town and village with a post office (loaded on first use),
       shown with its district and state. */
    if (IW && IW_READY && out.length < 40) {
      var rows = IW_RES[q];
      if (rows) rows.slice(0, 40 - out.length).forEach(function (r) { out.push(r); });
      else if (!IW_ASKED[q]) { IW_ASKED[q] = 1; IW.postMessage({ q: q }); }
    }
    var I = window.__JK_INDIA;
    if (I && I.p && out.length < 40) {
      if (!I._k) I._k = I.p.map(function (r) { return r[0].toLowerCase(); });
      var s2 = [], h2 = [];
      for (var j = 0; j < I._k.length; j++) {
        var k2 = I._k[j];
        if (k2.indexOf(q) === 0) { s2.push(j); if (s2.length >= 40) break; }
        else if (q.length >= 4 && h2.length < 20 && k2.indexOf(q) > -1) h2.push(j);
      }
      s2.concat(h2).slice(0, 40 - out.length).forEach(function (j) {
        var r = I.p[j], d = I.d[r[1]];
        out.push({ name: r[0], country: d[0] + ', ' + I.s[d[1]] + ', India', lat: r[2] / 100, lon: r[3] / 100, tz: 'Asia/Kolkata', pop: null });
      });
    }
    return out;
  }

  document.querySelectorAll('[data-city-ac]').forEach(function (input) {
    var box = input.closest('.city-field');
    var listEl = box.querySelector('.city-list');
    var lat = box.querySelector('[data-city-lat]'), lon = box.querySelector('[data-city-lon]'), tz = box.querySelector('[data-city-tz]');
    var note = box.querySelector('[data-city-note]');
    var src = input.getAttribute('data-cities-src');
    var indiaSrc = input.getAttribute('data-india-src');
    var items = [], active = -1, chosen = '';

    function setNote(text, cls) { note.textContent = text; note.className = 'city-note' + (cls ? ' ' + cls : ''); }
    function close() { listEl.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function clearChoice() { lat.value = lon.value = tz.value = ''; chosen = ''; }
    function choose(c) {
      input.value = c.name + (c.country ? ', ' + c.country : '');
      lat.value = c.lat; lon.value = c.lon; tz.value = c.tz;
      chosen = input.value;
      input.setCustomValidity('');
      setNote(window.aiT('Time zone') + ' ' + c.tz, 'is-ok');
      close();
    }
    input._aiChoose = choose;
    /* Step one of the order form asks this before moving on: a place from the list, or the first exact match. */
    input._aiEnsure = function () {
      if (lat.value) return true;
      var want = input.value.split(',')[0].trim().toLowerCase();
      var exact = citySearch(input.value).filter(function (c) { return c.name.toLowerCase() === want; });
      if (exact.length) { choose(exact[0]); return true; }
      window.aiFieldError(input, window.aiT('Please choose your birth place from the list.'));
      input.focus();
      render();
      return false;
    };
    function render() {
      items = citySearch(input.value);
      if (!items.length) {
        close();
        if (input.value.trim().length >= 2 && window.__JK_CITIES) setNote(window.aiT('No match. Check the spelling, or type the nearest larger town.'), 'is-err');
        return;
      }
      setNote('');
      listEl.innerHTML = items.map(function (c, i) {
        var pop = c.pop == null ? '' : c.pop >= 1000 ? Math.round(c.pop / 1000) + 'M' : c.pop + 'k';
        return '<div class="city-opt" role="option" id="' + (input.id || 'p-place') + '-o' + i + '" data-i="' + i + '"><b>' + esc(c.name) + '</b><span>' + esc(c.country) + '</span><em>' + pop + '</em></div>';
      }).join('');
      listEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }
    function ensureData() {
      /* the small-town list follows in the background; an open list refreshes when it lands */
      if (indiaSrc) indiaWorker(indiaSrc, function (q) {
        if (document.activeElement !== input || lat.value || input.value.trim().length < 2) return;
        if (q === undefined || q === input.value.split(',')[0].trim().toLowerCase()) render();
      });
      if (window.__JK_CITIES) return Promise.resolve();
      setNote(window.aiT('Loading places…'));
      return loadScript(src).then(function () { setNote(''); });
    }

    input.addEventListener('focus', function () {
      ensureData();
      /* Phones: lift the field above the keyboard so the suggestions can be seen. */
      if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
        setTimeout(function () {
          var h = document.querySelector('.site-header');
          var off = (h ? Math.max(0, h.getBoundingClientRect().bottom) : 0) + 10;
          var top = box.getBoundingClientRect().top;
          if (Math.abs(top - off) > 30) window.scrollTo({ top: top + window.pageYOffset - off, behavior: 'smooth' });
        }, 350);
      }
    });
    input.addEventListener('input', function () {
      if (input.value !== chosen) clearChoice();
      input.setCustomValidity('');
      ensureData().then(function () { if (document.activeElement === input) render(); });
    });
    input.addEventListener('keydown', function (e) {
      if (listEl.hidden) return;
      var opts = listEl.querySelectorAll('.city-opt');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = Math.max(0, Math.min(opts.length - 1, active + (e.key === 'ArrowDown' ? 1 : -1)));
        opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); });
        opts[active].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', opts[active].id);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        choose(items[active >= 0 ? active : 0]);
      } else if (e.key === 'Escape') { close(); }
    });
    /* mousedown so the choice lands before the input loses focus */
    listEl.addEventListener('mousedown', function (e) {
      var o = e.target.closest('.city-opt');
      if (!o) return;
      e.preventDefault();
      choose(items[+o.getAttribute('data-i')]);
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });

    /* Ask for a place from the list, so the report is cast for the right town and time zone. */
    var form = input.form;
    if (form) form.addEventListener('submit', function (e) {
      if (lat.value) return;
      var found = citySearch(input.value);
      if (found.length) {
        var exact = found.filter(function (c) { return c.name.toLowerCase() === input.value.split(',')[0].trim().toLowerCase(); });
        /* Typed a town name without tapping the list: the places are sorted by size,
           so the first exact name is almost always the one meant (Hyderabad, India
           before Hyderabad, Pakistan). The chosen place and time zone show under the field. */
        if (exact.length >= 1) { choose(exact[0]); return; }
        e.preventDefault();
        input.setCustomValidity(window.aiT('Please choose your birth place from the list.'));
        input.reportValidity();
        input.focus();
        render();
      }
    });
  });

  /* ---------- report buy form: keep the time field honest ---------- */
  document.querySelectorAll('[data-unknown-time]').forEach(function (cb) {
    var input = $id(cb.getAttribute('data-unknown-time'));
    if (!input) return;
    cb.addEventListener('change', function () {
      if (input._aiOff) { input._aiOff(cb.checked); return; }
      input.disabled = cb.checked;
      input.required = !cb.checked;
      if (cb.checked) input.value = '';
    });
  });

  /* ---------- report buy form: fill it from the free Kundli just made ---------- */
  var buyForm = $id('buy-form');
  if (buyForm && AI.prefill !== false) {
    var filled = false;
    var setIf = function (id, v) { var el = $id(id); if (el && !el.value && v) { if (el._aiSet) el._aiSet(v); else el.value = v; return true; } return false; };
    var last = null;
    try { last = (JSON.parse(lsGet('jk_recent') || '[]') || [])[0] || null; } catch (e) {}
    if (last && !/^example/i.test(last.name || '') && last.y && last.mo && last.d) {
      var p2 = function (n) { return String(n).padStart(2, '0'); };
      if (setIf('p-name', last.name)) filled = true;
      if (setIf('p-date', last.y + '-' + p2(last.mo) + '-' + p2(last.d))) filled = true;
      var hh = Math.floor(last.h), mm = Math.round((last.h - hh) * 60);
      if (mm === 60) { hh += 1; mm = 0; }
      if (last.h !== 12 && setIf('p-time', p2(hh) + ':' + p2(mm))) filled = true;
      var place = $id('p-place');
      if (place && !place.value && last.place && isFinite(last.lat) && isFinite(last.lon) && last.tzname) {
        var parts = String(last.place).split(',');
        if (place._aiChoose) place._aiChoose({ name: parts[0].trim(), country: parts.slice(1).join(',').trim(), lat: last.lat, lon: last.lon, tz: last.tzname });
        filled = true;
      }
    }
    setIf('p-email', lsGet('ai_email'));
    setIf('p-mobile', lsGet('ai_phone'));
    var pf = $id('aiPrefill');
    if (filled && pf) pf.classList.add('is-on');
  }

  /* ---------- sticky buy bar on phones ---------- */
  var stickyBuy = document.querySelector('[data-sticky-buy]');
  var buyBox = $id('buy');
  if (stickyBuy && buyBox && 'IntersectionObserver' in window) {
    stickyBuy.hidden = false;
    new IntersectionObserver(function (en) {
      var on = !en[0].isIntersecting && window.matchMedia('(max-width:960px)').matches;
      stickyBuy.classList.toggle('is-on', on);
      document.body.classList.toggle('has-sticky', on);
    }).observe(buyBox);
    stickyBuy.querySelector('a').addEventListener('click', function (e) {
      e.preventDefault();
      buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var target = null;
      if (buyForm) buyForm.querySelectorAll('input[required],select[required]').forEach(function (i) { if (!target && !i.disabled && !i.value && i.offsetParent) target = i; });
      setTimeout(function () { if (target) target.focus({ preventScroll: true }); }, 500);
    });
  }

  /* ---------- sample pages: tap to enlarge ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zoom]');
    if (!b) return;
    var src = b.getAttribute('data-zoom');
    track('astroindie_sample_zoom', { page: AI.tpl || '' });
    var dlg = document.createElement('dialog');
    if (typeof dlg.showModal !== 'function') { window.open(src, '_blank'); return; }
    dlg.className = 'ai-zoom';
    dlg.innerHTML = '<button type="button" aria-label="Close">&times;</button><img alt="">';
    dlg.querySelector('img').src = src;
    dlg.querySelector('img').alt = (b.querySelector('img') || {}).alt || 'Sample report page';
    document.body.appendChild(dlg);
    dlg.addEventListener('close', function () { dlg.remove(); });
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg || ev.target.tagName === 'BUTTON') dlg.close(); });
    dlg.showModal();
  });
})();

/* Keep the WhatsApp button off the main action buttons while they are on screen. */
(function () {
  var wa = document.querySelector('.ai-wa');
  if (!wa || !('IntersectionObserver' in window)) return;
  var seen = new Set();
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) seen.add(x.target); else seen.delete(x.target); });
    wa.classList.toggle('is-away', seen.size > 0);
  });
  var watch = function () { document.querySelectorAll('#cast, .buybox__actions, .ai-leadcard form').forEach(function (el) { if (!el._aiWa) { el._aiWa = 1; io.observe(el); } }); };
  watch();
  document.addEventListener('jk:result', function () { setTimeout(watch, 50); });
})();

/* ---------- Leaving? One nudge, once ----------
   Shown only on a real sign of leaving -- the pointer heading for the tab bar
   on a computer; on a phone, a quick swipe back up the page -- and never on
   arrival, so it stays clear of Google's rules on intrusive pop-ups. The Back
   button is deliberately not caught: since 15 June 2026 Google Search treats
   that as "back button hijacking" and demotes the site for it. Once shown it
   does not come back on any page for the rest of the visit, nor for the time
   set in Theme settings > Selling (12 hours unless changed).
   Test mode, for the shop owner: add ?exit_test=1 to any page address (and
   ?exit_test=0 to end it; it also ends when the tab is closed). The pop-up then
   comes up on every try, straight away, and nothing is remembered or sent to
   analytics. A yellow note in the pop-up says why it came up and, if the
   coupon version is missing, why. Buyers still never see it (see aiIsBuyer at
   the top of this file): on such a device a short message says so instead.
   What it says depends on where the visitor is:
     report page, details half typed -> finish the order (report is emailed)
     report page, nothing typed      -> read the free sample first
     free Kundli on screen           -> the Full Birth Chart, in terms of that chart
     nothing cast yet                -> read a complete sample of the full report */
(function () {
  var tpl = (window.AI && AI.tpl) || '';
  if (/^(cart|password|gift_card|404)$/.test(tpl) || /customers/.test(tpl)) return;
  var TEST = false;
  try {
    var tq = new URLSearchParams(location.search).get('exit_test');
    if (tq === '1') sessionStorage.setItem('ai_exit_test', '1');
    if (tq === '0') sessionStorage.removeItem('ai_exit_test');
    TEST = sessionStorage.getItem('ai_exit_test') === '1';
  } catch (e) {}
  var KEY = 'ai_nudged';
  var restH = parseFloat(window.AI && AI.exitRest);
  if (isNaN(restH) || restH < 0) restH = 12;
  var REST = restH * 3600 * 1000;                            // 0: once a visit, no longer
  function seen() {
    if (TEST) return false;
    try { if (sessionStorage.getItem(KEY) === '1') return true; } catch (e) {}
    try { var t = +localStorage.getItem(KEY); if (REST && t && Date.now() - t < REST) return true; } catch (e) {}
    return false;
  }
  function mark() {
    if (TEST) return;
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  if (seen()) return;
  var t0 = Date.now(), shown = false, buying = false, buyerTold = false;
  var buyForm = document.getElementById('buy-form');
  var track = TEST ? function () {} : (window.aiTrack || function () {});
  /* test mode only: a note inside the pop-up saying why it came up, and why the coupon version is missing if it is */
  function testNote(dlg, trigger, kind) {
    if (!TEST) return;
    var W = (window.AI && AI.exitWhy) || [];
    var why = { 'exit-intent': 'the pointer went up towards the tabs', 'scroll-up': 'a quick swipe back up the page' }[trigger] || trigger;
    var msg = 'Test mode: shown because ' + why + '.';
    if (kind === 'offer') { if (W[1]) msg += ' No second choice, because ' + W[1] + '.'; }
    else if (kind === 'finish') msg += ' The order form has details typed in, so this version asks them to finish the order instead of showing the coupon.';
    else if (W[0]) msg += ' The coupon version is not shown because ' + W[0] + '.';
    msg += ' Close it and it will come up again on your next try.';
    var p = document.createElement('p');
    p.className = 'ai-exit__test';
    p.textContent = msg;
    p.style.cssText = 'margin:10px 18px 0;padding:8px 10px;border-radius:8px;background:#FEF3C7;color:#78350F;font-size:.82rem;line-height:1.4;text-align:left';
    dlg.appendChild(p);
  }
  function q(s) { return document.querySelector(s); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function filled(f) {
    if (!f) return false;
    return ['p-name', 'p-date', 'p-place'].some(function (id) { var el = document.getElementById(id); return el && el.value.trim(); });
  }
  var typed = false;                                         // typed by the visitor, not pre-filled
  if (buyForm) {
    buyForm.addEventListener('submit', function () { buying = true; });
    buyForm.addEventListener('input', function (e) { if (e.isTrusted) typed = true; });
  }

  var lastKind = '';
  document.addEventListener('jk:result', function (e) { lastKind = (e.detail && e.detail.kind) || ''; });
  function content() {
    var h1 = q('.pr-hero h1, main h1');
    var title = ((h1 && (h1.getAttribute('data-title') || (h1.firstChild && h1.firstChild.textContent))) || 'your report').trim();
    var T = window.aiTf, N = function (n) { return (window.AILang && AILang.name) ? AILang.name(n) : n; };
    var sample = q('[data-track="astroindie_sample_open"]');
    var live = document.body.classList.contains('jk-live');
    var engine = q('.jk-root');
    if (buyForm && filled(buyForm)) return {
      k: 'finish', h: 'Your report is one step away',
      p: T('You have already entered the birth details. Finish now and your {0} is emailed to you as a PDF within minutes of paying.', esc(N(title))),
      a: { label: 'Finish my order', go: function () { var b = buyForm.querySelector('[data-step-next]:not([disabled]):not([hidden])') || buyForm.querySelector('[data-buy]') || buyForm.querySelector('[type="submit"]'); buyForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (b) b.focus(); } }
    };
    if (buyForm) return {
      k: 'sample', h: 'Not sure yet?',
      p: T('Read a complete sample of the {0} first, for an example birth. Yours is written for your own chart.', esc(N(title))),
      a: sample ? { label: 'Read a sample', href: sample.getAttribute('href') } : { label: 'Get my free Kundli', href: '/#free-kundli' },
      b: { label: 'Get my free Kundli', href: '/#free-kundli' }
    };
    var FULL = (window.AI && AI.full) || {};
    var BUY_FULL = (window.AI && AI.buy) || 'Get my report';
    var pages = FULL.pages || '80';
    var goForm = function () {
      if (window.aiOpenFree) window.aiOpenFree();
      var y = engine.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      setTimeout(function () { var f = document.getElementById('fname'); if (f && f.offsetParent) f.focus({ preventScroll: true }); }, 450);
    };
    /* A free Kundli is on screen: offer the whole reading, in terms of this chart. */
    if (live && FULL.url) {
      var f = (lastKind === 'kundali' && window.aiFacts && window.aiFacts()) || {};
      var canPdf = lastKind === 'kundali' && typeof window.downloadPDF === 'function' && !localStorage_get('ai_got_pdf');
      return {
        k: 'full', kicker: 'Full Birth Chart',
        h: f.name ? T('{0}, there is much more in your chart', esc(f.name)) : T('There is much more in your chart'),
        facts: [f.asc ? T('{0} rising', f.asc) : '', f.moon ? T('{0} Moon', f.moon) : '', f.lord ? T('{0} chapter to {1}', f.lord, f.until) : ''].filter(Boolean),
        p: f.lord ? T('Your free Kundli covers who you are. The Full Birth Chart goes on to career, marriage, money and health, explains what your {0} chapter is for, and dates the next 12 years.', f.lord)
                  : T('Your free Kundli covers who you are. The Full Birth Chart goes on to career, marriage, money and health, and dates the next 12 years.'),
        checks: [T('<b>Fine-tuned to your life:</b> add a few past events and your dates are weighted by them'),
                 T('About {0} pages, written for your chart only', esc(pages)),
                 T('PDF in your inbox within minutes. Your birth details are already filled in.')],
        price: true,
        a: { label: BUY_FULL, href: FULL.url + '#buy' },
        b: canPdf ? { label: 'Save my free Kundli PDF first', go: function () { localStorage_set('ai_got_pdf', '1'); track('astroindie_free_pdf', { page: tpl, from: 'nudge' }); window.downloadPDF(); } }
          : FULL.sample ? { label: 'Read a sample', href: FULL.sample } : null
      };
    }
    /* Nothing cast yet: the strongest thing to show is the product itself, free to read. */
    if (FULL.url) return {
      k: 'sample-full', kicker: 'Before you go',
      h: FULL.sample ? 'Read a complete Full Birth Chart, free' : 'See what a full reading covers',
      p: FULL.sample
        ? 'The whole sample report for an example birth: about ' + esc(pages) + ' pages, with the timing fine-tuned to past life events. Nothing to sign up for.'
        : 'About ' + esc(pages) + ' pages for your own chart: career, marriage, money and health, with the timing fine-tuned to your own life events.',
      checks: ['Career, marriage, money and health, each with dates', 'Timing checked against things that already happened', 'Yours is written for your own birth details'],
      a: FULL.sample ? { label: 'Read a sample', href: FULL.sample } : { label: 'See the Full Birth Chart', href: FULL.url },
      b: engine && engine.closest('.frame') ? { label: 'Get my free Kundli', go: goForm } : { label: 'Get my free Kundli', href: '/#free-kundli' }
    };
    return {
      k: 'free', h: 'Before you go: your free Kundli',
      p: 'Moon sign, Lagna, Nakshatra and your lucky factors, explained in plain English. Ready in 30 seconds, no sign-up.',
      a: { label: 'Get my free Kundli', href: '/#free-kundli' }
    };
  }
  function localStorage_get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function localStorage_set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function show(trigger) {
    if (shown || buying || seen()) return;
    if (window.aiIsBuyer()) {                                       // buyers never see it, in test mode too
      if (TEST && !buyerTold && window.aiToast) { buyerTold = true; window.aiToast('Test mode: not shown, because this phone or computer (or the signed-in account) has an order. Buyers never see the offer.', 7000); }
      return;
    }
    if (document.querySelector('dialog[open]') || document.documentElement.classList.contains('menu-open')) return;
    if (document.getElementById('pdfov')) return;                 // a PDF is being made
    var c = content();
    var O = window.AI && AI.offer;
    if (O && c.k !== 'finish') { shown = true; mark(); offer(O, trigger); return; }
    shown = true; mark();
    var dlg = document.createElement('dialog');
    if (typeof dlg.showModal !== 'function') return;
    dlg.className = 'ai-exit';
    dlg.setAttribute('aria-labelledby', 'ai-exit-h');
    var btn = function (x, cls) {
      var af = cls === 'gbtn--buy' ? ' autofocus' : '';        // focus lands on the main action, not on the close button
      return x.href ? '<a class="gbtn ' + cls + '" href="' + esc(x.href) + '" data-x' + af + '>' + esc(x.label) + '</a>'
                    : '<button class="gbtn ' + cls + '" type="button" data-x' + af + '>' + esc(x.label) + '</button>';
    };
    var F = (window.AI && AI.full) || {};
    if (!c.kicker) dlg.className += ' ai-exit--plain';
    dlg.innerHTML = '<button class="ai-exit__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="ai-exit__top">' + (c.kicker ? '<p class="ai-exit__kicker">' + esc(c.kicker) + '</p>' : '') +
        '<h2 id="ai-exit-h">' + c.h + '</h2>' +
        (c.facts && c.facts.length ? '<ul class="ai-exit__facts">' + c.facts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
      '</div><div class="ai-exit__body"><p>' + c.p + '</p>' +
        (c.checks ? '<ul class="ai-checks">' + c.checks.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>' : '') +
        (c.price && F.price ? '<div class="ai-exit__price"><b>' + esc(F.price) + '</b>' + (F.was ? '<s>' + esc(F.was) + '</s>' : '') + '<span>One-time payment. No subscription.</span></div>' : '') +
        '<div class="ai-exit__acts">' + btn(c.a, 'gbtn--buy') + (c.b ? btn(c.b, 'gbtn--ghost') : '') + '</div>' +
        '<button class="ai-exit__no" type="button">No thanks</button></div>';
    document.body.appendChild(dlg);
    var acts = dlg.querySelectorAll('[data-x]');
    [c.a, c.b].forEach(function (x, i) {
      if (!x || !acts[i]) return;
      acts[i].addEventListener('click', function () {
        track('astroindie_exit_click', { kind: c.k, page: tpl, choice: i ? 'second' : 'first' });
        dlg.close();
        if (x.go) x.go();
      });
    });
    testNote(dlg, trigger, c.k);
    dlg.addEventListener('close', function () { dlg.remove(); if (TEST) shown = false; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('.ai-exit__close, .ai-exit__no')) dlg.close();
    });
    dlg.showModal();
    track('astroindie_exit_shown', { kind: c.k, page: tpl, trigger: trigger });
  }

  /* The leaving offer: two clear choices, side by side in weight.
       1. The Full Birth Chart with money off: the code is shown (and can be
          copied) and the button goes through Shopify's /discount/ link, so the
          money off is already on the order at checkout.
       2. A smaller, cheaper report (the Diwali Report by default; Theme settings > Selling). */
  var SHORT = { diwali: 'Lakshmi Puja time for your city, and your year ahead', half: 'Your next 6 months, week by week', annual: 'Your year ahead, week by week', love: 'Your love life, the next 2 years',
    marriage: 'When marriage is likely, dated', career: 'Your next career move, dated', sade: 'Your Sade Sati, phase by phase' };
  function offer(O, trigger) {
    var T = window.aiTf, N = function (n) { return (window.AILang && AILang.name) ? AILang.name(n) : n; };
    var dlg = document.createElement('dialog');
    if (typeof dlg.showModal !== 'function') return;
    dlg.className = 'ai-exit ai-offer';
    dlg.setAttribute('aria-labelledby', 'ai-exit-h');
    var two = O.second;
    dlg.innerHTML =
      '<button class="ai-exit__close" type="button" aria-label="' + esc(T('Close')) + '">&times;</button>' +
      '<div class="ai-offer__top" tabindex="-1" autofocus>' +
        '<p class="ai-offer__kicker"><span aria-hidden="true">✦</span> ' + esc(T('Before you go')) + '</p>' +
        '<h2 id="ai-exit-h">' + esc(T('A gift for your first report')) + '</h2>' +
      '</div>' +
      '<div class="ai-offer__body">' +
        '<a class="ai-offer__card ai-offer__card--main" href="' + esc(O.url) + '" data-x="coupon">' +
          '<span class="ai-offer__tag">' + esc(T('Best value')) + '</span>' +
          '<span class="ai-offer__row"><span class="ai-offer__name">' + esc(N('Full Birth Chart')) + '</span>' +
            '<span class="ai-offer__price"><b>' + esc(O.now) + '</b><s>' + esc(O.list) + '</s></span></span>' +
          '<span class="ai-offer__line">' + esc(T('₹{0} off with code', O.off)) + ' <code class="ai-offer__code">' + esc(O.code) + '</code></span>' +
          '<span class="gbtn gbtn--buy ai-offer__go">' + esc(T('Get ₹{0} off now', O.off)) + '</span>' +
        '</a>' +
        (two ? '<p class="ai-offer__or"><span>' + esc(T('or')) + '</span></p>' +
          '<a class="ai-offer__card ai-offer__card--two" href="' + esc(two.url) + '" data-x="second">' +
            '<span class="ai-offer__row"><span class="ai-offer__name">' + esc(N(two.title)) + '</span><span class="ai-offer__price"><b>' + esc(two.price) + '</b></span></span>' +
            '<span class="ai-offer__line">' + esc(T(SHORT[two.mode] || '')) + '</span>' +
            '<span class="gbtn gbtn--ghost ai-offer__go">' + esc(T('Start with {0}', N(two.title))) + '</span>' +
          '</a>' : '') +
        '<button class="ai-exit__no" type="button">' + esc(T('No thanks')) + '</button>' +
      '</div>';
    document.body.appendChild(dlg);
    dlg.querySelectorAll('[data-x]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var k = a.getAttribute('data-x');
        track('astroindie_offer_click', { choice: k, code: k === 'coupon' ? O.code : '', page: tpl });
        if (k !== 'coupon') return;
        /* copy the code, say so, then go to the Full Birth Chart with the code on the checkout */
        e.preventDefault();
        try { sessionStorage.setItem('ai_coupon', O.code); sessionStorage.setItem('ai_go_buy', '1'); } catch (err) {}
        var go = a.querySelector('.ai-offer__go');
        a.classList.add('is-done');
        if (go) go.innerHTML = '<span aria-hidden="true">✓</span> ' + esc(T('Discount code copied'));
        var leave = function () { setTimeout(function () { location.href = O.url; }, 900); };
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(O.code).then(leave, leave);
          else leave();
        } catch (err) { leave(); }
      });
    });
    testNote(dlg, trigger, 'offer');
    dlg.addEventListener('close', function () { dlg.remove(); if (TEST) shown = false; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('.ai-exit__close, .ai-exit__no')) dlg.close();
    });
    dlg.showModal();
    track('astroindie_offer_shown', { page: tpl, trigger: trigger });
  }

  /* computer: the pointer leaves through the top of the window, towards the
     tabs, the address bar and Back. (A quick hand can be 20px down when the
     browser last sees it, so the top 20px count.) */
  document.addEventListener('mouseout', function (e) {
    if (e.relatedTarget || e.clientY > 20) return;
    if (!TEST && Date.now() - t0 < 6000) return;
    show('exit-intent');
  });
  /* phone: there is no pointer to watch, and the Back button is not caught
     (see the top of this block). The sign used is a quick swipe back up the
     page, which is how a phone reader brings back the address bar, the tabs
     and Back: the page carried up by at least 70% of a screen within 0.6 s, or
     all the way back to the top in one sweep. Only after 12 seconds and a
     screen's worth of reading, and only when a finger moved the page: a button
     that scrolls up to the Kundli form does not count. Never while typing.
     Coming back to the tab after switching apps is not a sign of leaving:
     people step away to ask a parent for a birth time. No pop-up for that. */
  if (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) {
    var maxY = 0, trail = [], fingerY = null, pullAt = 0;
    window.addEventListener('touchstart', function (e) { fingerY = e.touches[0] ? e.touches[0].clientY : null; pullAt = 0; }, { passive: true });   // a new touch: a tap on a button is not a swipe
    window.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (!t) return;
      if (fingerY != null && t.clientY - fingerY > 2) pullAt = Date.now();   // finger going down = page going up
      fingerY = t.clientY;
    }, { passive: true });
    var inField = function () { var a = document.activeElement; return !!a && /^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName); };
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset, now = Date.now(), vh = window.innerHeight || 700;
      if (y > maxY) maxY = y;
      trail.push({ t: now, y: y });
      while (trail.length && now - trail[0].t > 1600) trail.shift();
      if (now - pullAt > 1200) return;                      // the page moved by itself, not by a swipe
      if (!TEST && (now - t0 < 12000 || maxY < vh)) return;
      if (typed || inField()) return;
      var hiQuick = y, hiSweep = y;
      for (var i = 0; i < trail.length; i++) {
        if (trail[i].y > hiSweep) hiSweep = trail[i].y;
        if (now - trail[i].t <= 600 && trail[i].y > hiQuick) hiQuick = trail[i].y;
      }
      if (hiQuick - y > vh * 0.7 || (y < 120 && hiSweep - y > vh)) show('scroll-up');
    }, { passive: true });
  }

  /* The birth details are typed but the order is not placed: the browser's own
     "leave this page?" check, so they are not lost by a stray tap. */
  window.addEventListener('beforeunload', function (e) {
    if (buying || !typed || !filled(buyForm)) return;
    e.preventDefault(); e.returnValue = '';
  });
})();

/* ---------- Light / dark ----------
   One button at the right end of the top strip (and a pair in the phone
   menu). Until the visitor chooses, the page follows their phone or computer:
   that is settled in <head>, before the first paint. A choice made here is
   remembered on this device under the key the report engine also uses, so the
   site and a report opened inside it always agree. */
(function () {
  var root = document.documentElement;
  var bar = document.querySelector('meta[name="theme-color"]');
  var scheme = document.querySelector('meta[name="color-scheme"]');
  var lightBar = bar ? bar.getAttribute('content') : '';
  function current() { return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'; }
  function paint() {
    var t = current(), other = t === 'dark' ? 'Light' : 'Dark';
    document.querySelectorAll('[data-theme-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-theme-set') === t));
    });
    document.querySelectorAll('[data-theme-label]').forEach(function (el) { el.textContent = other; });
    if (bar) bar.setAttribute('content', t === 'dark' ? '#1C1529' : lightBar);
    if (scheme) scheme.setAttribute('content', 'light dark');       // with the stylesheet's own rule, this stops browsers darkening the page on their own
    var eb = document.getElementById('theme');            // the report bar's own button
    if (eb) eb.textContent = other;
  }
  function set(t) {
    root.setAttribute('data-theme', t);
    try { localStorage.setItem('jk_theme', t); } catch (err) {}
    paint();
    if (window.aiTrack) window.aiTrack('astroindie_theme', { theme: t });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-theme-set],[data-theme-toggle]');
    if (!b) return;
    set(b.hasAttribute('data-theme-toggle') ? (current() === 'dark' ? 'light' : 'dark') : (b.getAttribute('data-theme-set') === 'dark' ? 'dark' : 'light'));
  });
  if ('MutationObserver' in window) new MutationObserver(paint).observe(root, { attributes: true, attributeFilter: ['data-theme'] });
  paint();
})();

/* ---------- Report order form: optional life events ----------
   The rows are written into one order property, "Life events", as
   type@date pairs (marriage@2016-11-20, job@2019-04-15). The report engine
   reads exactly that. Nothing is sent when no complete row is filled in. */
(function () {
  var box = document.getElementById('aiTune');
  if (!box) return;
  var rows = box.querySelector('[data-tune-rows]');
  var out = box.querySelector('[data-tune-out]');
  var add = box.querySelector('[data-tune-add]');
  var tag = box.querySelector('.ai-tune__o');
  var MAX = 8;
  var today = new Date(), iso = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
  function collect() {
    var list = [];
    rows.querySelectorAll('.ai-tune__row').forEach(function (r) {
      var t = r.querySelector('[data-tune-type]').value, d = r.querySelector('[data-tune-date]').value;
      if (t && /^\d{4}-\d{2}-\d{2}$/.test(d) && d <= iso) list.push(t + '@' + d);
    });
    out.value = list.join(', ');
    out.disabled = !list.length;
    if (tag) { tag.textContent = list.length ? list.length + ' added' : 'Optional'; tag.classList.toggle('is-on', list.length > 0); }
    return list;
  }
  rows.addEventListener('change', collect);
  rows.addEventListener('input', collect);
  if (add) add.addEventListener('click', function () {
    if (rows.children.length >= MAX) return;
    var c = rows.firstElementChild.cloneNode(true), n = rows.children.length + 1;
    c.querySelector('[data-tune-type]').value = '';
    c.querySelector('[data-tune-type]').setAttribute('aria-label', 'Life event ' + n);
    c.querySelector('[data-tune-date]').value = '';
    c.querySelectorAll('.dparts select').forEach(function (x) { x.value = ''; });
    rows.appendChild(c);
    if (window.aiDparts) window.aiDparts(c.querySelector('[data-dparts]'));
    if (rows.children.length >= MAX) add.hidden = true;
  });
  var form = box.closest('form');
  if (form) form.addEventListener('submit', collect, true);
  box.addEventListener('toggle', function () { if (box.open && window.aiTrack) window.aiTrack('astroindie_tune_open', {}); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-open-tune]');
    if (!a) return;
    e.preventDefault();
    box.open = true;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();


/* ---------- Report order form: two short steps ----------
   Step one is the birth details, step two the email and the button that pays.
   Step two's fields are switched off until step one is complete, so the
   browser never checks a field the buyer cannot see. Without this script the
   two steps simply show one under the other. */
(function () {
  var form = document.getElementById('buy-form');
  if (!form) return;
  var s1 = form.querySelector('[data-step="1"]'), s2 = form.querySelector('[data-step="2"]');
  var next = form.querySelector('[data-step-next]');
  if (!s1 || !s2 || !next) return;
  var sum = form.querySelector('[data-step-sum]'), sumText = form.querySelector('[data-step-sumtext]');
  var dots = form.querySelectorAll('[data-step-dot]');
  var box = form.closest('.buybox') || form;
  var at = 0;
  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function txt(id) { var el = document.getElementById(id); return el && el._aiText ? el._aiText() : ''; }
  function summary() {
    var parts = [val('p-name'), txt('p-date'), txt('p-time'), val('p-place')].filter(Boolean);
    if (sumText) sumText.textContent = parts.join(' · ');
    if (sum) sum.hidden = !parts.length;
  }
  function show(n, move) {
    at = n;
    s1.hidden = n !== 1;
    s2.hidden = n !== 2;
    s2.disabled = n !== 2;
    next.hidden = n !== 1;
    next.disabled = n !== 1;
    dots.forEach(function (d) { var k = +d.getAttribute('data-step-dot'); d.classList.toggle('is-on', k === n); d.classList.toggle('is-done', k < n); });
    if (!move) return;
    var top = box.getBoundingClientRect().top, h = document.querySelector('.site-header');
    var off = (h ? Math.max(0, h.getBoundingClientRect().bottom) : 0) + 10;
    if (top < off || top > window.innerHeight * 0.5) window.scrollTo({ top: top + window.pageYOffset - off, behavior: 'smooth' });
    var f = n === 2 ? document.getElementById('p-email') : document.getElementById('p-name');
    if (f && n === 2 && !f.value) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
  }
  function stepOneOk() {
    var bad = null;
    s1.querySelectorAll('input, select').forEach(function (el) {
      if (!bad && !el.disabled && el.type !== 'hidden' && !el.checkValidity()) bad = el;
    });
    if (bad) {
      var fl = bad.closest('.field'), lid = fl && fl.querySelector('[id$="-l"]') ? fl.querySelector('[id$="-l"]').id : bad.id;
      var named = { 'p-name': 'Please enter the full name.', 'p-date-l': 'Please choose the date of birth.', 'p-time-l': 'Please choose the time of birth.', 'p-place': 'Please type the birth place and pick it from the list.' };
      var msg = bad.validity && bad.validity.valueMissing ? window.aiT(named[lid] || 'Please fill this in.') : (bad.validationMessage || window.aiT('Please fill this in.'));
      window.aiFieldError(bad, msg);
      var r = bad.getBoundingClientRect(), hh = document.querySelector('.site-header');
      window.scrollTo({ top: r.top + window.pageYOffset - (hh ? hh.getBoundingClientRect().bottom : 0) - 96, behavior: 'smooth' });
      setTimeout(function () { try { bad.focus({ preventScroll: true }); } catch (e) {} }, 300);
      return false;
    }
    var place = document.getElementById('p-place');
    if (place && place._aiEnsure && !place._aiEnsure()) return false;
    return true;
  }
  form.classList.add('is-steps');
  show(1);
  next.addEventListener('click', function () {
    if (!stepOneOk()) return;
    summary();
    show(2, true);
    if (window.aiTrack) window.aiTrack('astroindie_form_step2', { mode: next.getAttribute('data-mode') || '' });
  });
  form.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-step-back]')) show(1, true);
  });
  /* Enter in a step-one box moves on, as a "Next" key on a phone keyboard would. */
  s1.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.defaultPrevented || !e.target.matches('input[type="text"]')) return;
    var list = document.getElementById('p-place-list');
    if (e.target.id === 'p-place' && list && !list.hidden) return;
    e.preventDefault();
    next.click();
  });
  /* The email typed here goes with the buyer to the checkout, already filled in. */
  form.addEventListener('submit', function () {
    var em = document.getElementById('p-email'), v = em ? em.value.trim() : '';
    if (!v || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) return;
    form.querySelectorAll('input[name="return_to"]').forEach(function (r) {
      r.value = '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(v);
    });
  });
  /* Back from the checkout with the form restored by the browser: stay where the details are. */
  window.addEventListener('pageshow', function (e) { if (e.persisted && at === 2) summary(); });
})();

/* ---------- Report page: tap-to-open rows ----------
   A link to a row (#inside, #look, #fine-tuning) opens it; on a wide screen the
   first row starts open, since there is room beside the order form. */
(function () {
  var folds = document.querySelectorAll('[data-fold] > details');
  if (!folds.length) return;
  function openHash() {
    var id = (location.hash || '').slice(1);
    if (!id) return false;
    var el = document.getElementById(id);
    if (!el || el.tagName !== 'DETAILS' || !el.closest('[data-fold]')) return false;
    el.open = true;
    setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    return true;
  }
  if (!openHash() && window.matchMedia('(min-width: 901px)').matches) {
    var first = document.querySelector('[data-fold] > [data-fold-first]');
    if (first) first.open = true;
  }
  window.addEventListener('hashchange', openHash);
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.open && d.id && d.closest && d.closest('[data-fold]') && window.aiTrack) window.aiTrack('astroindie_fold_open', { row: d.id });
  }, true);
})();

/* ---------- One report per order ----------
   The button goes straight to payment. If an earlier, abandoned attempt is
   still in the cart, the checkout would show two reports and double the
   price, so the cart is emptied first. If that call cannot be made the order
   goes ahead anyway. */
(function () {
  var form = document.getElementById('buy-form');
  if (!form || !window.fetch) return;
  var sent = false;
  function reset() {
    sent = false;
    form.querySelectorAll('[data-buy]').forEach(function (b) { b.classList.remove('is-busy'); if (b._aiLabel) b.textContent = b._aiLabel; });
  }
  form.addEventListener('submit', function (e) {
    if (e.defaultPrevented || sent) return;
    e.preventDefault();
    sent = true;
    var done = false, go = function () { if (done) return; done = true; form.submit(); };
    form.querySelectorAll('[data-buy]').forEach(function (b) { b._aiLabel = b.textContent; b.classList.add('is-busy'); b.textContent = window.aiT('Taking you to payment…'); });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var timer = setTimeout(go, 2500);
    fetch(root + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .catch(function () {})
      .then(function () { clearTimeout(timer); go(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
})();


/* ---------- Motion: sections ease in once as they reach the screen ----------
   Anything marked data-reveal (or data-reveal-group, whose children follow one
   after another) starts a little low and faded, and settles when a fifth of
   it is on screen. The styles only apply under html.js and when the visitor
   has not asked for less motion, so nothing is ever hidden without this. */
(function () {
  var els = document.querySelectorAll('[data-reveal],[data-reveal-group]');
  if (!els.length) return;
  var show = function (el) { el.classList.add('is-in'); };
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (calm || !('IntersectionObserver' in window)) { els.forEach(show); return; }
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { show(x.target); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  els.forEach(function (el) {
    /* already on screen at arrival (or above it, after a jump to an anchor): show at once */
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.92) show(el); else io.observe(el);
  });
  /* a printout or a jump straight to the bottom never leaves anything faded */
  window.addEventListener('beforeprint', function () { els.forEach(show); });
  window.addEventListener('hashchange', function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) show(el); }); });
})();

/* ---------- Header: a hairline and a soft shadow once the page moves ---------- */
(function () {
  var h = document.querySelector('[data-header]');
  if (!h) return;
  var on = false, q = false;
  var sync = function () { q = false; var y = window.pageYOffset > 8; if (y !== on) { on = y; h.classList.toggle('is-scrolled', y); } };
  window.addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(sync); } }, { passive: true });
  sync();
})();


/* ---------- The site's language: English or हिन्दी ----------
   Asked once, on the first visit (a small sheet with two big choices), and
   changeable any time from the top of the page, the menu, or the order form.
   The choice is kept on this device under the same key the report engine
   reads ("jk_lang"), so the report a visitor orders, the free Kundli and the
   reports in My reports all come up in the same language as the site.

   How the Hindi is shown: the page is written in English, and the Hindi
   dictionary (ai-hi.js, loaded only for Hindi readers) is applied to it in
   place. Each run of text (a heading, a paragraph with its bold words and
   links, a button label) is looked up whole; numbers and report names are
   lifted out first, so "₹299" or "Marriage Forecast" inside a sentence need no
   entry of their own. Anything the dictionary does not have stays in English
   rather than being guessed. Text the theme adds later (a pop-up, a new row in
   the form) is translated as it appears. Switching back to English puts the
   original words back. The report itself is translated by the report engine,
   which has its own, much larger dictionary.

   Order details keep English property names and values: they are what the
   order and the email carry. */
(function () {
  var HI = {
    'One-time payment. Emailed as a PDF within minutes of paying.': 'एक बार का भुगतान। भुगतान के कुछ ही मिनटों में PDF ईमेल पर।',
    'Birth details': 'जन्म विवरण', 'Email and pay': 'ईमेल और भुगतान',
    '✓ Filled in from the Kundli you just made. Please check the details.': '✓ आपने अभी जो कुण्डली बनाई, उससे भरा गया है। कृपया विवरण जाँच लें।',
    'Full name': 'पूरा नाम', 'Date of birth': 'जन्म तिथि', 'Time of birth': 'जन्म का समय', 'Place of birth': 'जन्म स्थान',
    'Required. Not sure of it? Use the free': 'ज़रूरी है। समय पक्का नहीं? पहले मुफ़्त', 'Fix birth time': 'जन्म समय शोधन',
    'tool first, then order with the time it finds.': 'टूल से अपना सही समय निकालें, फिर उसी समय के साथ ऑर्डर करें।',
    'Start typing your city, town or village': 'अपना शहर, कस्बा या गाँव लिखना शुरू करें',
    'Day': 'दिन', 'Month': 'महीना', 'Year': 'वर्ष', 'Hour': 'घंटा', 'Min': 'मिनट',
    'Where you are in love right now': 'प्रेम जीवन में आप अभी कहाँ हैं', '(optional)': '(वैकल्पिक)',
    'Prefer not to say': 'बताना नहीं चाहते', 'Single': 'सिंगल', 'In a relationship': 'रिश्ते में', 'Married': 'विवाहित', 'Separated or divorced': 'अलग या तलाक़शुदा',
    'It changes the advice in your report more than anything else.': 'आपकी रिपोर्ट की सलाह पर इसका सबसे ज़्यादा असर पड़ता है।',
    'Where will you celebrate Diwali?': 'दिवाली कहाँ मनाएँगे?', 'Leave blank to use your birth place': 'खाली छोड़ें तो जन्म स्थान लिया जाएगा',
    'Puja times depend on the city: sunset and the rising sign move with the place.': 'पूजा का समय शहर पर निर्भर है: सूर्यास्त और लग्न जगह के साथ बदलते हैं।',
    'I run a business or trade': 'मेरा व्यापार या कारोबार है', '(adds the Chopda pujan times)': '(चोपड़ा पूजन के मुहूर्त जुड़ेंगे)',
    'Fine-tune it with your life events': 'अपने जीवन की घटनाओं से इसे सटीक बनाएँ',
    'Add 3 dates from your past and your forecast is weighted to your own life.': 'अपने अतीत की 3 तारीखें जोड़ें, और भविष्यफल आपके अपने जीवन के अनुसार तौला जाएगा।',
    'Add what happened in your last Sade Sati': 'पिछली साढ़ेसाती में क्या हुआ, जोड़ें',
    'A few dated events from that time and the reading adjusts to how Saturn has really worked for you.': 'उस समय की कुछ घटनाएँ तारीख़ के साथ जोड़ें, और रिपोर्ट देखेगी कि शनि ने असल में आप पर कैसे काम किया।',
    'Optional': 'वैकल्पिक',
    'Things that have already happened. Three or more works best. Not sure of a date? Leave that one out.': 'जो घटनाएँ पहले हो चुकी हैं। तीन या ज़्यादा सबसे अच्छा। किसी तारीख़ पर पक्का नहीं? उसे छोड़ दें।',
    'Choose an event': 'घटना चुनें', 'Marriage': 'विवाह', 'New job or promotion': 'नई नौकरी या पदोन्नति', 'Moved city or went abroad': 'शहर बदला या विदेश गए',
    'Birth of a child': 'संतान का जन्म', 'Bought property or a home': 'संपत्ति या घर ख़रीदा', 'Started a business': 'व्यवसाय शुरू किया',
    'Major exam or degree': 'बड़ी परीक्षा या डिग्री', 'Big financial gain': 'बड़ा आर्थिक लाभ', 'Big financial loss': 'बड़ा आर्थिक नुक़सान',
    'Serious illness or surgery': 'गंभीर बीमारी या सर्जरी', 'Loss of father': 'पिता का निधन', 'Loss of mother': 'माता का निधन',
    '+ Add another event': '+ एक और घटना जोड़ें', 'Continue': 'आगे बढ़ें', 'Edit': 'बदलें',
    'Email to send the report to': 'रिपोर्ट किस ईमेल पर भेजें', 'Mobile number': 'मोबाइल नंबर',
    'Secure checkout': 'सुरक्षित भुगतान', 'UPI · cards · net banking': 'UPI · कार्ड · नेट बैंकिंग',
    'Instant PDF · one-time': 'तुरंत PDF · एक बार का भुगतान',
    'That month has only {n} days.': 'उस महीने में केवल {n} दिन होते हैं।', 'This date is in the future.': 'यह तारीख़ भविष्य की है।',
    'Time zone': 'समय क्षेत्र', 'Please choose your birth place from the list.': 'कृपया सूची में से अपना जन्म स्थान चुनें।',
    'No match. Check the spelling, or type the nearest larger town.': 'कोई मेल नहीं मिला। वर्तनी जाँचें, या पास का बड़ा शहर लिखें।',
    'Loading places…': 'जगहें लोड हो रही हैं…', 'Please fill this in.': 'कृपया यह जानकारी भरें।',
    'Please enter the full name.': 'कृपया पूरा नाम लिखें।', 'Please choose the date of birth.': 'कृपया जन्म तिथि चुनें।',
    'Please choose the time of birth.': 'कृपया जन्म का समय चुनें।', 'Please type the birth place and pick it from the list.': 'कृपया जन्म स्थान लिखें और सूची में से चुनें।', 'Taking you to payment…': 'भुगतान पर ले जा रहे हैं…'
  };
  var INLINE = { B: 1, I: 1, EM: 1, STRONG: 1, SPAN: 1, A: 1, SUP: 1, SUB: 1, SMALL: 1, U: 1, BR: 1, ABBR: 1, MARK: 1, S: 1, TIME: 1, CODE: 1, Q: 1 };
  var ISLAND = '.ai-freecard,.ai-leadcard,#ai-next';           // the theme's own cards inside the report
  var SKIP = 'script,style,svg,noscript,template,textarea,input,canvas,iframe,[data-no-i18n],[lang="sa"],:not(html)[lang="hi"],.city-list,.ai-lang,' +
    '.jk-root #report,.jk-root #topstack,.jk-root #tabs,.jk-root #tabin,.jk-root #bar,.jk-root .langrow,.jk-root #sky';
  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt'];
  var D = null;                                    // the loaded dictionary
  var lang = 'en';
  var units = [];                                  // what was changed, to put back
  var NAMES = [];                                  // report and tool names, lifted out of sentences
  var root = document.documentElement;

  function dict(k) { return (D && D[k]) || HI[k]; }
  window.aiT = function (t) { return lang === 'hi' ? (dict(t) || t) : t; };
  /* planet, sign and month names inside a script-built sentence */
  var WORD = {
    Sun: 'सूर्य', Moon: 'चंद्र', Mars: 'मंगल', Mercury: 'बुध', Jupiter: 'गुरु', Venus: 'शुक्र', Saturn: 'शनि', Rahu: 'राहु', Ketu: 'केतु',
    Aries: 'मेष', Taurus: 'वृषभ', Gemini: 'मिथुन', Cancer: 'कर्क', Leo: 'सिंह', Virgo: 'कन्या', Libra: 'तुला', Scorpio: 'वृश्चिक',
    Sagittarius: 'धनु', Capricorn: 'मकर', Aquarius: 'कुंभ', Pisces: 'मीन',
    Jan: 'जनवरी', Feb: 'फ़रवरी', Mar: 'मार्च', Apr: 'अप्रैल', May: 'मई', Jun: 'जून', Jul: 'जुलाई', Aug: 'अगस्त', Sep: 'सितंबर', Sept: 'सितंबर', Oct: 'अक्टूबर', Nov: 'नवंबर', Dec: 'दिसंबर'
  };
  function hiWords(v) { return String(v).replace(/[A-Z][a-z]+/g, function (w) { return WORD[w] || w; }); }
  window.aiTf = function (t) {
    var a = [].slice.call(arguments, 1);
    return window.aiT(t).replace(/\{(\d+)\}/g, function (m, i) { var v = a[+i]; if (v == null) return ''; return lang === 'hi' ? hiWords(v) : v; });
  };

  /* ----- keys: "₹{0} for the {1}" with the numbers and names as slots ----- */
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function abstract(s) {
    var slots = [];
    var parts = s.split(/(<\/?\d+\/?>)/);
    for (var i = 0; i < parts.length; i += 2) {
      var t = parts[i];
      if (!t) continue;
      NAMES.forEach(function (n) {
        var en = esc(n);
        if (t.indexOf(en) < 0) return;
        t = t.split(en).join('\uE000' + String.fromCharCode(0xE100 + slots.length));
        slots.push({ v: n, name: 1 });
      });
      t = t.replace(/\d+(?:[.,:]\d+)*/g, function (m) { slots.push({ v: m }); return '\uE000' + String.fromCharCode(0xE100 + slots.length - 1); });
      parts[i] = t;
    }
    var order = [];
    var key = parts.join('').replace(/\uE000([\uE100-\uE1FF])/g, function (m, c) { order.push(slots[c.charCodeAt(0) - 0xE100]); return '{' + (order.length - 1) + '}'; });
    return { key: key.replace(/\s+/g, ' ').trim(), slots: order };
  }
  function fill(hi, slots) {
    return hi.replace(/\{(\d+)\}/g, function (m, i) {
      var s = slots[+i]; if (!s) return '';
      return s.name ? esc(dict('@' + s.v) || s.v) : s.v;
    });
  }
  function lookup(a) {
    var hi = dict(a.key);
    if (hi == null && !hasWords(a.key) && a.slots.some(function (x) { return x.name; })) hi = a.key;
    return hi == null ? null : hi;
  }
  function hasWords(k) { return /[A-Za-z]{2}/.test(k.replace(/<\/?\d+\/?>/g, '').replace(/\{\d+\}/g, '')); }
  /* Hindi for a plain string, or null */
  function plain(str) {
    if (!str || !/[A-Za-z]{2}/.test(str)) return null;
    var a = abstract(esc(str.replace(/\s+/g, ' ').trim()));
    var hi = lookup(a);
    if (hi === null) return null;
    return fill(hi, a.slots).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  }

  /* ----- units: an element of only text and inline tags, or a lone text node ----- */
  function inlineOnly(el) {
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 1) {
        if (!INLINE[c.tagName] || c.matches(SKIP) || c.hasAttribute('data-hi') || !inlineOnly(c)) return false;
      } else if (c.nodeType !== 3 && c.nodeType !== 8) return false;
    }
    return true;
  }
  function skipped(n) {
    var el = n.nodeType === 1 ? n : n.parentElement;
    if (!el) return true;
    if (el.closest(ISLAND)) return false;
    return !!el.closest(SKIP);
  }
  var SKIP_ATTR = SKIP.replace(/,input|,textarea/g, '');
  function skippedAttr(el) { return el.closest(ISLAND) ? false : !!el.closest(SKIP_ATTR); }
  function collect(el, out) {
    if (el.nodeType !== 1) return;
    if (el.matches(SKIP) && !el.matches(ISLAND)) { el.querySelectorAll(ISLAND).forEach(function (i) { collect(i, out); }); return; }
    if (el.hasAttribute('data-hi')) { out.push({ el: el, hi: el.getAttribute('data-hi') }); return; }
    /* an element with words of its own and only inline tags is one unit; one
       whose words all sit in child tags is read child by child */
    if (el.tagName !== 'OPTION' && inlineOnly(el)) {
      var own = false;
      for (var c = el.firstChild; c; c = c.nextSibling) if (c.nodeType === 3 && /[A-Za-z]/.test(c.nodeValue)) { own = true; break; }
      if (own) { out.push({ el: el }); return; }
    }
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3) { if (/[A-Za-z]{2}/.test(c.nodeValue)) out.push({ text: c }); }
      else if (c.nodeType === 1) collect(c, out);
    }
  }
  function serialise(el) {
    var tags = [], s = '';
    (function ser(n) {
      for (var c = n.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) s += esc(c.nodeValue);
        else if (c.nodeType === 1) {
          var i = tags.length; tags.push(c);
          if (c.tagName === 'BR' || !c.firstChild) s += '<' + i + '/>';
          else { s += '<' + i + '>'; ser(c); s += '</' + i + '>'; }
        }
      }
    })(el);
    return { s: s, tags: tags };
  }
  function keyOf(u) {
    if (u.hi !== undefined) return null;
    if (u.text) return abstract(esc(u.text.nodeValue)).key;
    return abstract(serialise(u.el).s).key;
  }

  function translateUnit(u) {
    if (u.hi !== undefined) {
      var el = u.el;
      if (el.__aiEn === undefined) { el.__aiEn = el.textContent; units.push({ el: el, kind: 'text' }); }
      if (!el.classList.contains('is-busy')) el.textContent = u.hi;
      return true;
    }
    if (u.text) {
      var t = u.text, v = t.nodeValue;
      var a = abstract(esc(v)), hi = lookup(a);
      if (hi === null) return false;
      if (t.__aiEn === undefined) { t.__aiEn = v; units.push({ node: t }); }
      var lead = /^\s/.test(v) ? ' ' : '', trail = /\s$/.test(v) ? ' ' : '';
      t.nodeValue = lead + fill(hi, a.slots).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&') + trail;
      return true;
    }
    var el = u.el, ser = serialise(el);
    var a = abstract(ser.s), hi = lookup(a);
    if (hi === null) return false;
    var out = fill(hi, a.slots).replace(/<(\/?)(\d+)(\/?)>/g, function (m, c, k, sc) {
      var t = ser.tags[+k]; if (!t) return '';
      if (sc) return t.outerHTML;
      if (c) return '</' + t.tagName.toLowerCase() + '>';
      var o = t.outerHTML; return o.slice(0, o.indexOf('>') + 1);
    });
    var lead = /^\s/.test(el.innerHTML) ? ' ' : '', trail = /\s$/.test(el.innerHTML) ? ' ' : '';
    if (el.__aiEn === undefined) { el.__aiEn = el.innerHTML; units.push({ el: el, kind: 'html' }); }
    el.innerHTML = lead + out + trail;
    return true;
  }
  function translateAttrs(scope) {
    var list = [scope].concat([].slice.call(scope.querySelectorAll('[placeholder],[aria-label],[title],[alt]')));
    list.forEach(function (el) {
      if (el.nodeType !== 1 || !el.getAttribute || skippedAttr(el)) return;
      ATTRS.forEach(function (n) {
        var v = el.getAttribute(n); if (!v) return;
        var hi = plain(v); if (!hi) return;
        el.__aiAttr = el.__aiAttr || {};
        if (el.__aiAttr[n] === undefined) { el.__aiAttr[n] = v; units.push({ attr: n, el: el }); }
        el.setAttribute(n, hi);
      });
    });
  }
  var misses = {};
  function translate(scope) {
    if (lang !== 'hi' || !scope || skipped(scope)) return;
    var list = [];
    if (scope.nodeType === 3) { if (scope.parentElement) collect(scope.parentElement, list); }
    else collect(scope, list);
    list.forEach(function (u) {
      if (!translateUnit(u)) { var k = keyOf(u); if (k && hasWords(k)) misses[k] = 1; }
    });
    if (scope.nodeType === 1) {
      translateAttrs(scope);
      scope.querySelectorAll('option').forEach(function (o) {
        if (skipped(o)) return;
        var hi = plain(o.textContent); if (!hi) return;
        if (o.__aiEn === undefined) { o.__aiEn = o.textContent; units.push({ el: o, kind: 'text' }); }
        o.textContent = hi;
      });
    }
  }
  function restore() {
    units.splice(0).reverse().forEach(function (u) {
      if (u.node) { if (u.node.__aiEn !== undefined) { u.node.nodeValue = u.node.__aiEn; u.node.__aiEn = undefined; } }
      else if (u.attr) { if (u.el.__aiAttr && u.el.__aiAttr[u.attr] !== undefined) { u.el.setAttribute(u.attr, u.el.__aiAttr[u.attr]); delete u.el.__aiAttr[u.attr]; } }
      else if (u.el.__aiEn !== undefined) {
        if (u.kind === 'html') u.el.innerHTML = u.el.__aiEn;
        else if (!u.el.classList.contains('is-busy')) u.el.textContent = u.el.__aiEn;
        u.el.__aiEn = undefined;
      }
    });
  }

  /* ----- text added later: translated as it arrives ----- */
  var busy = false, queue = [], mo = null;
  function flush() {
    var q = queue.splice(0);
    busy = true;
    q.forEach(function (n) { if (n.isConnected) translate(n); });
    if (mo) mo.takeRecords();
    busy = false;
  }
  function watch() {
    if (mo || !('MutationObserver' in window)) return;
    mo = new MutationObserver(function (recs) {
      if (busy || lang !== 'hi') return;
      recs.forEach(function (r) {
        if (r.type === 'characterData' || r.type === 'attributes') queue.push(r.target);
        else r.addedNodes.forEach(function (n) { if (n.nodeType === 1 || n.nodeType === 3) queue.push(n.nodeType === 3 ? n : n); });
      });
      if (queue.length) Promise.resolve().then(flush);
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder', 'title'] });
  }

  /* ----- the dictionary, fetched once ----- */
  var loading = null;
  function load() {
    if (D) return Promise.resolve(D);
    if (window.AI_HI) { D = window.AI_HI; return Promise.resolve(D); }
    if (loading) return loading;
    var url = (window.AI && AI.hiUrl) || '';
    loading = new Promise(function (ok) {
      var s = document.getElementById('ai-hi-js');
      var done = function () { D = window.AI_HI || null; ok(D); };
      if (s) {
        if (window.AI_HI) return done();
        s.addEventListener('load', done); s.addEventListener('error', done);
        return;
      }
      if (!url) return ok(null);
      s = document.createElement('script'); s.id = 'ai-hi-js'; s.src = url;
      s.onload = done; s.onerror = done;
      document.head.appendChild(s);
    });
    return loading;
  }

  function names() {
    if (!D) return;
    var al = (window.AI && AI.alias) || {};
    Object.keys(al).forEach(function (t) { if (D['@' + al[t]] && !D['@' + t]) D['@' + t] = D['@' + al[t]]; });
    NAMES = Object.keys(D).filter(function (k) { return k.charAt(0) === '@'; }).map(function (k) { return k.slice(1); })
      .sort(function (a, b) { return b.length - a.length; });
  }
  function reveal() { root.classList.remove('ai-hi-wait'); }

  function paintUi() {
    document.querySelectorAll('[data-ai-lang-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-ai-lang-set') === lang));
    });
    document.querySelectorAll('[data-ai-lang-toggle]').forEach(function (b) {
      var to = lang === 'hi' ? 'en' : 'hi';
      b.setAttribute('data-to', to);
      var l = b.querySelector('[data-ai-lang-label]');
      if (l) { l.textContent = to === 'hi' ? 'हिन्दी' : 'English'; l.setAttribute('lang', to); }
      b.setAttribute('aria-label', to === 'hi' ? 'हिन्दी में पढ़ें (Read in Hindi)' : 'Read in English (अंग्रेज़ी में पढ़ें)');
    });
    root.lang = lang === 'hi' ? 'hi' : 'en';
    root.classList.toggle('ai-hi', lang === 'hi');
  }

  var syncing = false;
  function set(l, opts) {
    opts = opts || {};
    l = l === 'hi' ? 'hi' : 'en';
    try { localStorage.setItem('jk_lang', l); } catch (e) {}
    var was = lang;
    if (l === 'en') {
      lang = 'en';
      busy = true; restore(); if (mo) mo.takeRecords(); busy = false;
      paintUi(); reveal();
      done(was, opts);
      return Promise.resolve();
    }
    return load().then(function (d) {
      if (!d) { lang = 'en'; paintUi(); reveal(); return; }
      if (window.AI && AI.buy && AI.buyHi) D[AI.buy] = AI.buyHi;
      names();
      /* the shop's own lines from Theme settings > Language: "English = हिन्दी" */
      if (window.AI && AI.hiExtra) String(AI.hiExtra).split(/\n/).forEach(function (line) {
        var i = line.indexOf(' = '); if (i < 1) return;
        var en = line.slice(0, i).replace(/\s+/g, ' ').trim(), hi = line.slice(i + 3).trim();
        if (!en || !hi) return;
        var a = abstract(esc(en));
        D[a.key] = hi.replace(/[&<>]/g, function (c) { return c === '&' ? '&amp;' : c === '<' ? '&lt;' : '&gt;'; });
        if (a.key !== esc(en)) D[esc(en)] = D[a.key];
      });
      lang = 'hi';
      paintUi();
      busy = true; translate(document.body); if (document.title) { var t = plain(document.title); if (t) { if (root.__aiTitle === undefined) root.__aiTitle = document.title; document.title = t; } } if (mo) mo.takeRecords(); busy = false;
      watch();
      reveal();
      done(was, opts);
    });
  }
  function done(was, opts) {
    if (opts.user) markAsked();
    if (lang === 'en' && root.__aiTitle !== undefined) { document.title = root.__aiTitle; root.__aiTitle = undefined; }
    document.dispatchEvent(new CustomEvent('ai:lang', { detail: { lang: lang, was: was, user: !!opts.user } }));
    if (opts.user && window.aiTrack) window.aiTrack('astroindie_site_lang', { lang: lang, from: opts.from || '', page: (window.AI && AI.tpl) || '' });
    /* a report open on this page follows the site */
    if (!syncing && was !== lang) {
      var eng = document.querySelector('.jk-root #bar [data-lang="' + lang + '"]');
      if (eng && eng.onclick) { syncing = true; try { eng.click(); } finally { syncing = false; } }
    }
  }

  window.AILang = {
    get: function () { return lang; }, set: set, load: load,
    t: window.aiT, plain: plain,
    /* for building the dictionary: every key this page would need */
    keys: function (scope) {
      var list = [], out = []; collect(scope || document.body, list);
      list.forEach(function (u) { var k = keyOf(u); if (k && hasWords(k)) out.push(k); });
      (scope || document.body).querySelectorAll('[placeholder],[aria-label],[title],[alt],option').forEach(function (el) {
        if (skippedAttr(el)) return;
        ATTRS.forEach(function (n) { var v = el.getAttribute(n); if (v) { var k = abstract(esc(v.replace(/\s+/g, ' ').trim())).key; if (hasWords(k)) out.push(k); } });
        if (el.tagName === 'OPTION') { var k = abstract(esc(el.textContent.replace(/\s+/g, ' ').trim())).key; if (hasWords(k)) out.push(k); }
      });
      return out;
    },
    misses: function () { return Object.keys(misses); },
    /* a report's name in the reading language */
    name: function (n) { return lang === 'hi' ? (dict('@' + n) || n) : n; },
    setNames: function (n) { NAMES = n.slice().sort(function (a, b) { return b.length - a.length; }); }
  };

  /* the report engine's own English / हिन्दी buttons move the whole site too */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.jk-root #bar [data-lang]');
    if (b && !syncing) { var l = b.getAttribute('data-lang'); if (l !== lang) { syncing = true; set(l, { user: true, from: 'report' }).then(function () { syncing = false; }); } }
    var s = e.target.closest && e.target.closest('[data-ai-lang-set],[data-ai-lang-toggle]');
    if (!s) return;
    e.preventDefault();
    var to = s.getAttribute('data-ai-lang-set') || s.getAttribute('data-to') || (lang === 'hi' ? 'en' : 'hi');
    var from = s.getAttribute('data-from') || 'switch';
    var dlg = s.closest('dialog');
    if (dlg) {
      /* the sheet stays until the page is in the chosen language */
      s.classList.add('is-busy');
      set(to, { user: true, from: from }).then(function () { s.classList.remove('is-busy'); closeAsk(dlg, to); });
      return;
    }
    set(to, { user: true, from: from });
  });

  /* ----- first visit: ask ----- */
  function markAsked() { try { localStorage.setItem('ai_lang_asked', '1'); } catch (e) {} try { sessionStorage.setItem('ai_lang_asked', '1'); } catch (e) {} }
  function closeAsk(dlg, chosen) {
    markAsked();
    try { localStorage.setItem('jk_lang', chosen || lang); } catch (e) {}
    dlg.classList.add('is-closing');
    var end = function () { if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else dlg.removeAttribute('open'); dlg.classList.remove('is-closing'); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) end(); else setTimeout(end, 220);
  }
  function ask() {
    var dlg = document.getElementById('ai-lang');
    if (!dlg || document.querySelector('dialog[open]')) return;
    /* older phone browsers (and some in-app browsers) without <dialog>: shown all the same */
    /* the language in use now is marked, so a returning visitor only has to tap it */
    dlg.querySelectorAll('[data-ai-lang-set]').forEach(function (b) { b.classList.toggle('is-current', b.getAttribute('data-ai-lang-set') === lang); });
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else { dlg.setAttribute('open', ''); dlg.classList.add('is-fallback'); }
    if (window.aiTrack) window.aiTrack('astroindie_lang_ask', { page: (window.AI && AI.tpl) || '' });
    /* Escape, or a tap outside the sheet: keep English, and do not ask again */
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeAsk(dlg, 'en'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeAsk(dlg, 'en'); });
  }

  /* ----- start ----- */
  var start = null, stored = null;
  try { var q = new URLSearchParams(location.search).get('lang'); if (q === 'hi' || q === 'en') start = q; } catch (e) {}
  try { stored = localStorage.getItem('jk_lang'); } catch (e) {}
  if (!start && (stored === 'hi' || stored === 'en')) start = stored;
  if (start) window.AILang.ready = set(start, {});
  else { paintUi(); reveal(); window.AILang.ready = Promise.resolve(); }
  /* Asked once per device. It does not wait for every image and outside script
     to finish loading (on a slow phone that can take many seconds): the page is
     ready, so it comes up a moment after the page is drawn. */
  if (root.classList.contains('ai-ask')) setTimeout(function tryAsk(n) {
    if (document.querySelector('dialog[open]') || root.classList.contains('menu-open')) { if ((n || 0) < 20) setTimeout(function () { tryAsk((n || 0) + 1); }, 1500); return; }
    ask();
  }, 600);
})();

/* ---------- The order form and the site's language ----------
   The order form's "Report language" choice is the site's language: picking
   हिन्दी there turns the whole site to Hindi, and a Hindi reader arriving here
   finds हिन्दी already chosen. The browser's own "Please fill out this field"
   follows too. */
(function () {
  var picker = document.querySelector('[data-lang-picker]');
  if (!picker) return;
  var box = document.getElementById('buy');
  function sync(l) {
    picker.querySelectorAll('[data-lang-pick]').forEach(function (r) { r.checked = r.getAttribute('data-lang-pick') === l; });
    if (box) { box.classList.toggle('is-hi', l === 'hi'); }
  }
  sync(window.AILang ? AILang.get() : 'en');
  document.addEventListener('ai:lang', function (e) { sync(e.detail.lang); });
  picker.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-lang-pick]');
    if (r && r.checked && window.AILang) AILang.set(r.getAttribute('data-lang-pick'), { user: true, from: 'order-form' });
  });
  /* the "English or हिन्दी" fact under the title takes the buyer straight to the choice */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-go-lang]');
    if (!a) return;
    e.preventDefault();
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    picker.classList.remove('is-flash'); void picker.offsetWidth; picker.classList.add('is-flash');
  });
  if (!box) return;
  box.addEventListener('invalid', function (e) {
    var el = e.target;
    if (window.AILang && AILang.get() === 'hi' && el.validity && el.validity.valueMissing) { el.setCustomValidity('कृपया यह जानकारी भरें।'); el._aiReq = 1; }
  }, true);
  ['input', 'change'].forEach(function (ev) {
    box.addEventListener(ev, function (e) { var el = e.target; if (el._aiReq) { el._aiReq = 0; el.setCustomValidity(''); } }, true);
  });
})();

/* ---------- footer: on a phone the link groups start folded ---------- */
(function () {
  var cols = document.querySelectorAll('[data-fcol]');
  if (!cols.length) return;
  var mq = window.matchMedia('(min-width: 900px)');
  var sync = function () { cols.forEach(function (d) { d.open = mq.matches; }); };
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  /* on a computer the groups are plain columns: they never close */
  cols.forEach(function (d) { d.addEventListener('toggle', function () { if (mq.matches && !d.open) d.open = true; }); });
})();

/* ---------- "How your forecast is made": a row of five; on a phone a tap opens it top to bottom ---------- */
(function () {
  var m = document.querySelector('[data-moat]');
  if (!m) return;
  var btn = m.querySelector('[data-moat-toggle]');
  var pulse = m.querySelector('.moat__pulse'), icos = m.querySelectorAll('.moat__ico');
  var wide = window.matchMedia('(min-width: 960px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* the spark runs from the first symbol to the last, whichever way they are laid out */
  function place() {
    if (!pulse || icos.length < 2) return;
    var box = m.getBoundingClientRect(), a = icos[0].getBoundingClientRect(), b = icos[icos.length - 1].getBoundingClientRect();
    pulse.style.left = (a.left - box.left + a.width / 2 - 4) + 'px';
    pulse.style.top = (a.top - box.top + a.height / 2 - 4) + 'px';
    pulse.style.setProperty('--rx', (b.left - a.left) + 'px');
    pulse.style.setProperty('--ry', (b.top - a.top) + 'px');
  }
  function set(open) {
    var apply = function () {
      m.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', String(open));
      place();
    };
    if (!calm.matches && document.startViewTransition) document.startViewTransition(apply);
    else { apply(); if (!calm.matches) { m.classList.remove('is-turning'); void m.offsetWidth; m.classList.add('is-turning'); } }
    if (window.aiTrack) window.aiTrack('astroindie_moat_' + (open ? 'open' : 'close'), {});
  }
  m.addEventListener('click', function () { if (!wide.matches) set(!m.classList.contains('is-open')); });
  place();
  window.addEventListener('resize', place);
  document.addEventListener('ai:lang', function () { setTimeout(place, 50); });
  if (wide.addEventListener) wide.addEventListener('change', function () { if (wide.matches && m.classList.contains('is-open')) set(false); place(); });
})();

/* ---------- the leaving offer's code, reminded on the order form ----------
   A visitor who took the Full Birth Chart offer sees, beside the buy button,
   that the money off is applied at checkout (and the code, in case it is needed). */
(function () {
  var O = window.AI && AI.offer, code = null;
  try { code = sessionStorage.getItem('ai_coupon'); } catch (e) {}
  if (!O || !code || code !== O.code) return;
  var form = document.getElementById('buy-form');
  if (!form || !window.AI.full || location.pathname.replace(/\/$/, '') !== String(AI.full.url).split('#')[0].split('?')[0].replace(/\/$/, '')) return;
  var ready = (window.AILang && AILang.ready) || Promise.resolve();
  ready.then(function () { place(); }, function () { place(); });
  function place() {
  var T = window.aiTf;
  var note = document.createElement('p');
  note.className = 'ai-coupon-note';
  note.innerHTML = '<span aria-hidden="true">✦</span> ' + T('Your price: {0} at checkout', '<b>' + O.now + '</b>') + ' <code>' + O.code + '</code>';
  var box = document.getElementById('buy') || form;
  box.insertBefore(note, box.firstChild);
  /* arriving from the offer: straight to the order form, with a word that the code is on */
  var fresh = false;
  try { fresh = sessionStorage.getItem('ai_go_buy') === '1'; sessionStorage.removeItem('ai_go_buy'); } catch (e) {}
  if (!fresh) return;
  setTimeout(function () { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
  if (window.aiToast) window.aiToast(T('Discount code {0} copied and applied', O.code));
  }
})();

/* ---------- After paying: "check your inbox" ----------
   The payment page itself belongs to Shopify, so the theme cannot write on it
   (see the note in the theme's README for the Thank you page). What the theme
   can do: when an order form is sent to payment it notes the report and the
   email on this device, and the next time the visitor is back on the site it
   checks the cart. Shopify empties the cart once an order is paid, so an empty
   cart means the order went through: the visitor is told the report is on its
   way to their inbox. A cart that still holds the report means payment was not
   finished, and nothing is said. The note is forgotten after three days. */
(function () {
  var KEY = 'ai_pending_order', DAYS = 3;
  var form = document.getElementById('buy-form');
  if (form) form.addEventListener('submit', function () {
    var h1 = document.querySelector('.pr-hero h1, main h1');
    var em = document.getElementById('p-email');
    var rec = { title: (h1 && (h1.getAttribute('data-title') || h1.textContent) || '').trim().slice(0, 80), email: em ? em.value.trim().slice(0, 120) : '', t: Date.now() };
    try { localStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) {}
  });
  var rec = null;
  try { rec = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!rec || !rec.t) return;
  if (Date.now() - rec.t > DAYS * 864e5) { try { localStorage.removeItem(KEY); } catch (e) {} return; }
  if (Date.now() - rec.t < 20000) return;                       // just sent: still on the way to payment
  if (!window.fetch) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return;
      if (cart.item_count > 0) { window.__aiCheckoutOpen = true; return; }   // payment not finished: the offer may help
      try { localStorage.removeItem(KEY); localStorage.setItem('ai_bought', String(Date.now())); sessionStorage.removeItem('ai_coupon'); } catch (e) {}
      show(rec);
    }).catch(function () {});

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function show(rec) {
    var T = window.aiTf, N = function (n) { return (window.AILang && AILang.name) ? AILang.name(n) : n; };
    var go = function () {
      if (document.querySelector('dialog[open]')) { setTimeout(go, 1500); return; }
      var dlg = document.createElement('dialog');
      if (typeof dlg.showModal !== 'function') { if (window.aiToast) window.aiToast(T('Your report is on its way. Check your email inbox.'), 8000); return; }
      dlg.className = 'ai-exit ai-paid';
      dlg.setAttribute('aria-labelledby', 'ai-paid-h');
      var my = (window.AI && AI.myUrl) || '';
      dlg.innerHTML =
        '<button class="ai-exit__close" type="button" aria-label="' + esc(T('Close')) + '">&times;</button>' +
        '<div class="ai-paid__in" tabindex="-1" autofocus>' +
          '<span class="ai-paid__ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="M3.5 7l8.5 6 8.5-6"/></svg></span>' +
          '<h2 id="ai-paid-h">' + esc(T('Thank you! Check your inbox')) + '</h2>' +
          '<p>' + (rec.title ? T('Your {0} is being prepared and will be emailed to you as a PDF within a few minutes.', '<b>' + esc(N(rec.title)) + '</b>')
                             : esc(T('Your report is being prepared and will be emailed to you as a PDF within a few minutes.'))) + '</p>' +
          (rec.email ? '<p class="ai-paid__mail">' + esc(T('Sent to')) + ' <b>' + esc(rec.email) + '</b></p>' : '') +
          '<ul class="ai-paid__tips">' +
            '<li>' + esc(T('Not there in 10 minutes? Look in Spam or Promotions.')) + '</li>' +
            (my ? '<li>' + T('It is also saved in {0}: sign in with the same email.', '<a href="' + esc(my) + '">' + esc(T('My reports')) + '</a>') + '</li>' : '') +
          '</ul>' +
          '<button class="gbtn gbtn--buy ai-paid__ok" type="button">' + esc(T('Got it')) + '</button>' +
        '</div>';
      document.body.appendChild(dlg);
      dlg.addEventListener('close', function () { dlg.remove(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('.ai-exit__close, .ai-paid__ok')) dlg.close(); });
      dlg.showModal();
      if (window.aiTrack) window.aiTrack('astroindie_paid_notice', { report: rec.title || '' });
    };
    var ready = (window.AILang && AILang.ready) || Promise.resolve();
    ready.then(function () { setTimeout(go, 400); }, function () { setTimeout(go, 400); });
  }
})();
